<template>
    <div>
        <div class="page_loader_cont" v-if="page_loader">
            <div class="spinner_height">
                <spinner-circle :black="true"></spinner-circle>
            </div>
        </div>
        <template v-else-if="role && role === 'crew'">
            <div class="row heading_cont_">
                <h3>All Grooming Sessions</h3>
                <div class="money" @click="open_money()">groomers' commission</div>
            </div>

            <div v-if=" sessions === '' || !sessions " class="no_result no_result_center">some error happend.</div>
            <div v-else-if=" sessions && Array.isArray(sessions) && sessions.length === 0 "
                class="no_result no_result_center">You don’t have any sessions yet.</div>
            <div v-else>
                <div class="scroll_y">
                    <div class="result_table_cont " v-if="sessions && Array.isArray(sessions) && sessions.length > 0">
                        <table class="c-admin_table"><!--style="direction: ltr"-->
                            <tr class="not_hover">
                                <th>#</th>
                                <th>Parent</th>
                                <th>Phone</th>
                                <th>Name</th>
                                <th>Type</th>
                                <th>Groomer</th>
                                <th>Status</th>
                                <th>Breed</th>
                                <th>created</th>
                                <th v-if="company === 'pets_club'">Total</th>
                                <th v-if="company !== 'pets_club'"></th>
                                <th></th>
                                <th></th>
                                <th></th>
                            </tr>

                            <tr v-for="(session, i) in sessions" :key="session.id"
                                :class="`tr_${make_undersocre(session.status)} ${is_sess_missing_groomer(i) === true ? 'missing_groomer': ''}` ">
                                <td>{{ table_num(i) }}</td>
                                <td class="parent_name">{{ session.parent_name }}</td>
                                <td v-if="company === 'pets_club'">{{ session.parent_phone }}</td>
                                <td v-else>{{ session.parent_phone  }} {{  single_or_multi_phone_txt(session)  }}</td>
                                <td>{{ session.pet_name }}</td>
                                <td>{{ session.pet_type }}</td>
                                <td class="groomer_td">{{ single_or_multi_groomer(session) }}</td>
                                <td>{{ session.status }}</td>
                                <td>{{ session.pet_breed }}</td>

                                <td>{{ session.createdAt }}</td>
                                <td v-if="company === 'pets_club'">{{ session.services_total }}</td>
                                <td v-if="company !== 'pets_club' && is_paid(i)" class="dollar_sign">$</td>
                                <td v-else-if="company !== 'pets_club' && is_paid(i) === false"></td>

                                <td class="">
                                    <div class="">
                                        <img @click="open_edit_sess(i)" src="@/assets/edit.svg" alt="editt"
                                            class="edit_icon">
                                    </div>
                                </td>
                                <td class="">
                                    <div class="">
                                        <img @click="open_delete(i)" src="@/assets/delete.svg" alt="editt"
                                            class="edit_icon">
                                    </div>
                                </td>
                                <td class="manage_td">
                                    <div class="manage" @click="manage_btn(i)">
                                        Manage
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </template>
        <VetHome v-else-if="role === 'vet'"></VetHome>
        <template v-else-if="role === 'super_admin'">
            <div class="column super_form_cont">
                <h2>The World Is Yours</h2>
                <form class="super_form" enctype="multipart/form-data">
                    <input type="text" placeholder="username" v-model="super_username">
                    <input type="text" placeholder="password" v-model="super_password">
                    <input type="text" placeholder="role" v-model="super_role">
                    <input type="file" accept="image/*" @change="uploadImage($event)" ref="img" class="none"
                        id="file-input" name="img">
                    <!-- <input type="file" id="imgg" name="img"> -->
                    <input type="text" placeholder="company" v-model="super_company">
                    <input type="text" placeholder="branch" v-model="super_branch">
                    <button @click.prevent="save_user()">
                        <div v-if="super_loading === true">Loading...</div>
                        <div v-else>Save</div>
                    </button>
                </form>
            </div>

        </template>
        <div v-else>error</div>


        <div class="sess_info_cont" v-if="show_sess_info">

            <div class=" sess_info">
                <div class="close_cont">
                    <div class="close" @click="close()">close</div>
                </div>
                <div class="groomers">
                    <div class="pet_name" v-if="current_sess">{{ current_sess.pet_name }}</div>
                    <!-- <div class="groomers_heading">pet info</div> -->
                    <div class="pet_info">{{ current_sess.pet_type }} - {{ current_sess.pet_sex }} - {{
                        current_sess.pet_breed }} - ({{ current_sess.pet_birthday }})</div>
                    <div v-if="company !== 'pets_club'" class="multiple_groomers_btn add_phone_btn_" @click="open_add_new_phone()">Add another phone
                        number</div>
                    <!-- <div class="pet_sex">{{ current_sess.pet_sex }}</div>
                    <div class="pet_breed">{{ current_sess.pet_breed }}</div>
                    <div class="pet_birthday">{{ current_sess.pet_birthday }}</div> -->
                    <div v-if="current_sess && current_sess.phones && current_sess.phones.length > 0">
                        <div class="row space_between another_phone_cont"
                            v-for="(phone, i) in JSON.parse(current_sess.phones)" :key="i">

                            <div class="another_phone">{{ phone }}</div>

                            <div class="row">
                                <div class="edit">
                                    <img src="@/assets/edit.svg" alt="editt" class="edit_icon"
                                        @click="open_edit_new_phone(phone, i)">
                                </div>
                                <div class="delete">
                                    <img src="@/assets/delete.svg" alt="deltee" class="edit_icon"
                                        @click="open_delete_phone(phone, i)">
                                </div>
                            </div>

                        </div>
                    </div>




                </div>


                <!-- show pop up to comfirm delete receipt id -->
                <div class="remove_receipt_id_pop_up" v-if="show_delete_new_phone_pop_up !== null">

                    <div class="remove_receipt_id_pop_up_cont">
                        <div class="remove_receipt_id_pop_up_title">Are you sure you want to delete this phone number
                            <b>{{ show_delete_new_phone_pop_up }}</b> ?
                        </div>

                        <!-- remove check-box -->
                        <div class="row add_phone_to_all_cont" v-if="show_check_box() === true">
                            <input type="checkbox" id="remove_phone_to_all" name="remove_phone_to_all" class="add_phone_to_all"
                                v-model="remove_phone_to_all">
                            <label for="remove_phone_to_all" class="font_size_14">Remove this phone from all today's sessions with same parents</label>
                        </div>

                        <div class="err" v-if="delete_new_phone_err !== null">{{  delete_new_phone_err  }}</div>
                        <div class="row remove_receipt_id_pop_up_btns_cont mr_top_15">
                            <button class="btn remove_receipt_id_pop_up_btn remove_receipt_id_pop_up_btn_cancel"
                                @click="close_delete_phone()">Cancel</button>
                            <button
                                class="btn btn_first_grooming delete_btn delete_txt remove_receipt_id_pop_up_btn remove_receipt_id_pop_up_btn_remove "
                                @click="delete_new_phone()">
                                <div class="loading" v-if="delete_new_phone_loading">
                                    <Spinner />
                                </div>
                                <div class="btn_txt" v-else>Delete</div>
                            </button>
                        </div>
                    </div>

                </div>



                <!-- show pop up to assign multiple groomers -->
                <div class="remove_receipt_id_pop_up" v-if="show_add_another_phone_window === true">

                    <div class="remove_receipt_id_pop_up_cont">
                        <div class="groomers_heading">Add another phone number</div>

                        <!-- <div>Hola</div> -->

                        <input type="tel" name="phone_2" id="phone_2" placeholder="phone number" class="phone_2_input"
                            v-model="new_phone_2">

                        <!-- add check-box -->
                        <div class="row add_phone_to_all_cont" v-if="show_check_box() === true">
                            <input type="checkbox" id="add_phone_to_all" name="add_phone_to_all" class="add_phone_to_all"
                                v-model="add_phone_to_all">
                            <label for="add_phone_to_all" class="font_size_15">Add this phone to all today's sessions
                                with same parents</label>
                        </div>

                        <div class="err" v-if="add_new_phone_err !== null">{{ add_new_phone_err }}</div>

                        <div class="row remove_receipt_id_pop_up_btns_cont mr_top_15">
                            <button
                                class="btn remove_receipt_id_pop_up_btn remove_receipt_id_pop_up_btn_cancel cencel_assign_groomers"
                                @click="close_add_new_phone()">Cancel</button>
                            <button
                                class="btn btn_first_grooming delete_txt remove_receipt_id_pop_up_btn remove_receipt_id_pop_up_btn_remove "
                                @click="add_new_phone()">
                                <div class="loading" v-if="new_phone_loading">
                                    <Spinner />
                                </div>
                                <div class="btn_txt" v-else>Save</div>
                            </button>
                        </div>
                    </div>

                </div>


                <!-- show pop up to assign multiple groomers -->
                <div class="remove_receipt_id_pop_up" v-if="show_edit_new_phone_window === true">

                    <div class="remove_receipt_id_pop_up_cont">
                        <div class="groomers_heading">Edit this phone number</div>

                        <!-- <div>Hola</div> -->

                        <input type="tel" name="phone_2_e" id="phone_2_e" placeholder="phone number"
                            class="phone_2_input" v-model="update_phone_2_var">
                            

                        <!-- update check-box -->
                        <div class="row add_phone_to_all_cont" v-if="show_check_box() === true">
                            <input type="checkbox" id="update_phone_to_all" name="update_phone_to_all" class="add_phone_to_all"
                                v-model="update_phone_to_all">
                            <label for="update_phone_to_all" class="font_size_14">Update this phone for all today's sessions with same parents</label>
                        </div>


                        <div class="err" v-if="update_new_phone_err !== null">{{ update_new_phone_err }}</div>
                        

                        <div class="row remove_receipt_id_pop_up_btns_cont mr_top_15">
                            <button
                                class="btn remove_receipt_id_pop_up_btn remove_receipt_id_pop_up_btn_cancel cencel_assign_groomers"
                                @click="close_edit_new_phone()">Cancel</button>
                            <button
                                class="btn btn_first_grooming delete_txt remove_receipt_id_pop_up_btn remove_receipt_id_pop_up_btn_remove "
                                @click="update_new_phone()">
                                <div class="loading" v-if="update_new_phone_loading">
                                    <Spinner />
                                </div>
                                <div class="btn_txt" v-else>Update</div>
                            </button>
                        </div>
                    </div>

                </div>


                <hr class="phone_hr">
                <div class="groomers">
                    <div class="groomers_heading">change services</div>
                    <div class="row groomers_names_cont">
                        <div :class="`${current_sess.shower === true ? 'groomer groomer_selected service' : 'groomer service'}`"
                            @click="select_service('shower')">
                            <spinner :black='true' v-if="service_loading !== null && service_loading === 'shower'">
                            </spinner>
                            <div v-else>shower</div>
                        </div>

                        <div :class="`${current_sess.medical_shower === true ? 'groomer groomer_selected service' : 'groomer service'}`"
                            @click="select_service('medical_shower')">
                            <spinner :black='true'
                                v-if="service_loading !== null && service_loading === 'medical_shower'"></spinner>
                            <div v-else>medical shower</div>
                        </div>

                        <div v-if="company === 'pets_club'"
                            :class="`${current_sess.chemical_shower === true ? 'groomer groomer_selected service' : 'groomer service'}`"
                            @click="select_service('chemical_shower')">
                            <spinner :black='true'
                                v-if="service_loading !== null && service_loading === 'chemical_shower'"></spinner>
                            <div v-else>chemical shower</div>
                        </div>

                        <div v-if="company === 'ziggy_pupps'"
                            :class="`${current_sess.dry_shower === true ? 'groomer groomer_selected service' : 'groomer service'}`"
                            @click="select_service('dry_shower')">
                            <spinner :black='true' v-if="service_loading !== null && service_loading === 'dry_shower'">
                            </spinner>
                            <div v-else>dry shower</div>
                        </div>

                        <div :class="`${current_sess.hair_cut === true ? 'groomer groomer_selected service' : 'groomer service'}`"
                            @click="select_service('hair_cut')">
                            <spinner :black='true' v-if="service_loading !== null && service_loading === 'hair_cut'">
                            </spinner>
                            <div v-else>hair cut</div>
                        </div>

                        <div :class="`${current_sess.hair_trimming === true ? 'groomer groomer_selected service' : 'groomer service'}`"
                            @click="select_service('hair_trimming')">
                            <spinner :black='true'
                                v-if="service_loading !== null && service_loading === 'hair_trimming'"></spinner>
                            <div v-else>hair trimming</div>
                        </div>

                        <div :class="`${current_sess.nail_trimming === true ? 'groomer groomer_selected service' : 'groomer service'}`"
                            @click="select_service('nail_trimming')">
                            <spinner :black='true'
                                v-if="service_loading !== null && service_loading === 'nail_trimming'"></spinner>
                            <div v-else>nail trimming</div>
                        </div>

                        <div v-if="current_sess.pet_type !== null && current_sess.pet_type === 'dog'"
                            :class="`${current_sess.anal_gland === true ? 'groomer groomer_selected service' : 'groomer service'}`"
                            @click="select_service('anal_gland')">
                            <spinner :black='true' v-if="service_loading !== null && service_loading === 'anal_gland'">
                            </spinner>
                            <div v-else>anal gland</div>
                        </div>


                    </div>

                    <div class="row groomer_input" v-if="company === 'pets_club' ">
                        <input type="number" placeholder="Services total" name="groomer_commission"
                            class="groomer_commission" v-model="service_t">
                        <button class="groomer_commission_btn" @click="add_service_total()">
                            <div class="loading" v-if="service_t_loading">
                                <Spinner />
                            </div>
                            <div class="btn_txt" v-else>Enter</div>
                        </button>
                    </div>
                    <div class="err" v-if="service_err === true">Error</div>
                    <div class="good" v-if="service_good === true ">Saved</div>
                </div>

                <!--

                <hr>

                <div class="groomers">

                    <div class="groomers_heading">services</div>
                    <div class=" groomers_names_cont" v-if="current_sess !== null">
                        <div class="service other no_poienter" v-if="current_sess.health_condition">{{ current_sess.health_condition }}</div>
                        <div class="service other no_poienter" v-if="current_sess.behavior_notes">{{ current_sess.behavior_notes }}</div>

                        <div class="service no_poienter" v-if="current_sess.shower">shower</div>
                        <div class="service no_poienter" v-if="current_sess.medical_shower">medical shower</div>
                        <div class="service no_poienter" v-if="current_sess.dry_shower">dry shower</div>
                        <div class="service no_poienter" v-if="current_sess.chemical_shower && company === 'pets_club'">chemical shower</div>
                        <div class="service no_poienter" v-if="current_sess.hair_cut">hair cut</div>
                        <div class="service no_poienter" v-if="current_sess.hair_trimming">hair trimming</div>
                        <div class="service no_poienter" v-if="current_sess.nail_trimming">nail trimming</div>
                        <div class="service no_poienter" v-if="current_sess.anal_gland">anal gland</div>
                        <div class="service other no_poienter" v-if="current_sess.other">{{ current_sess.other }}</div>
                        
                        <div class="row groomer_input" v-if="company === 'pets_club' ">
                            <input type="number" placeholder="Services total" name="groomer_commission"  class="groomer_commission" v-model="service_t">
                            <button class="groomer_commission_btn" @click="add_service_total()">
                                <div class="loading" v-if="service_t_loading" >
                                    <Spinner/>
                                </div>
                                <div class="btn_txt" v-else >Enter</div>
                            </button>
                        </div>
                        <div class="err" v-if="service_err === true">Error</div>
                        <div class="good" v-if="service_good === true ">Saved</div>



                        



                    </div>
                
                </div>

                -->

                <hr>
                <div class="groomers">
                    <!-- <div class="pet_name" v-if="current_sess">{{ current_sess.pet_name }}</div> -->
                    <div class="row groomers_heading choose_groomer_cont">
                        <div>choose groomer</div>
                        <div v-if="company !== 'pets_club'" class="multiple_groomers_btn" @click="open_add_multiple_groomer()">Assign multiple groomers
                        </div>
                    </div>
                    <div class="row groomers_names_cont"
                        v-if="groomers && Array.isArray(groomers) && groomers.length > 0">
                        <div :class="groomer_class(groomer.id)" v-for="groomer in groomers" :key="groomer.id"
                            @click="select_groomer(groomer.id, groomer.name, )">
                            <spinner :black='true'
                                v-if="groomer_id_loading !== null && groomer_id_loading === groomer.id"></spinner>
                            <div v-else>{{ groomer.name }}</div>
                        </div>
                    </div>

                    <div class="row groomer_input"
                        v-if="company === 'pets_club' && groomers && Array.isArray(groomers) && groomers.length > 0">
                        <input type="number" placeholder="Groomer's commission" name="groomer_commission"
                            class="groomer_commission" v-model="groomer_t">
                        <button class="groomer_commission_btn" @click="add_groomer_total()">
                            <div class="loading" v-if="groomer_c_loading">
                                <Spinner />
                            </div>
                            <div class="btn_txt" v-else>Enter</div>
                        </button>
                    </div>
                    <div class="err" v-if="groomer_c_err !== null">{{ groomer_c_err }}</div>
                    <div class="good" v-if="groomer_c_good === true ">Saved</div>



                </div>
                <hr>
                <!-- <div class="groomers_heading">choose groomer</div> -->

                <div class="groomers">
                    <div class="groomers_heading">change status</div>
                    <div class="row groomers_names_cont" v-if="status_ && Array.isArray(status_) && status_.length > 0">
                        <div :class="`${status === current_sess.status ? 'groomer groomer_selected' : 'groomer'}`"
                            v-for="(status, index) in status_" :key="index" @click="select_status(status)">
                            <spinner :black='true' v-if="status_txt_loading !== null && status_txt_loading === status">
                            </spinner>
                            <div v-else>{{ status }}</div>
                        </div>
                    </div>
                </div>









                <hr v-if="company !== 'pets_club'">
                <div class="groomers receipt_cont" v-if="company !== 'pets_club'">
                    <div class="groomers_heading">Receipts</div>

                    <!-- remove_company -->
                    <div class="row groomer_input" v-if="receipt_number_feature === true">
                        <input type="number" @keyup.enter="add_receipt_id()" placeholder="Receipt Number"
                            name="receipt_id" class="groomer_commission main_input" v-model="receipt_id">
                        <button class="groomer_commission_btn" @click="add_receipt_id()">
                            <div class="loading" v-if="receipt_id_loading">
                                <Spinner />
                            </div>
                            <div class="btn_txt" v-else>Add</div>
                        </button>
                    </div>


                    <!-- show only if receipt_id_loading_err not boolean and contant words -->
                    <div class="err"
                        v-if="receipt_id_loading_err && typeof receipt_id_loading_err !== 'boolean' && receipt_id_loading_err !== null && receipt_id_loading_err !== undefined && receipt_id_loading_err !== '' && receipt_id_loading_err.length > 0  ">
                        {{ receipt_id_loading_err }}</div>
                    <div class="err" v-else-if="receipt_id_loading_err === true">Error</div>
                    <div class="good" v-if="receipt_id_loading_good !== null ">{{ receipt_id_loading_good }}</div>

                    <!-- show all receipts added ids -->
                    <div class="row receipt_ids_cont"
                        v-if="receipt_number_feature === true && current_sess.receipts_id && Array.isArray(JSON.parse(current_sess.receipts_id)) && JSON.parse(current_sess.receipts_id).length > 0">
                        <div class="groomer receipt_id" v-for="(receipt_id_, i) in JSON.parse(current_sess.receipts_id)"
                            :key="i" @click="open_remove_receipt_id_pop_up(receipt_id_)">
                            {{ receipt_id_ }}
                        </div>
                    </div>

                    <!-- show pop up to comfirm delete receipt id -->
                    <div class="remove_receipt_id_pop_up" v-if="show_remove_receipt_id_pop_up !== null">

                        <div class="remove_receipt_id_pop_up_cont">
                            <div class="remove_receipt_id_pop_up_title">Are you sure you want to remove receipt number
                                <b>{{ show_remove_receipt_id_pop_up }}</b> ?
                            </div>
                            <div class="err" v-if="remove_receipt_id_err === true">Error</div>
                            <div class="row remove_receipt_id_pop_up_btns_cont">
                                <button class="btn remove_receipt_id_pop_up_btn remove_receipt_id_pop_up_btn_cancel"
                                    @click="close_remove_receipt_id_pop_up()">Cancel</button>
                                <button
                                    class="btn btn_first_grooming delete_btn delete_txt remove_receipt_id_pop_up_btn remove_receipt_id_pop_up_btn_remove "
                                    @click="remove_receipt_id()">
                                    <div class="loading" v-if="remove_receipt_id_loading">
                                        <Spinner />
                                    </div>
                                    <div class="btn_txt" v-else>Remove</div>
                                </button>
                            </div>
                        </div>

                    </div>

                    <!-- show pop up to assign multiple groomers -->
                    <div class="remove_receipt_id_pop_up" v-if="show_assign_multiple_groomers_window === true">

                        <div class="remove_receipt_id_pop_up_cont">
                            <div class="groomers_heading">Assign multiple groomers</div>

                            <div class="row space_between service_assign_g" v-if="current_sess.shower">
                                <div>shower</div>

                                <select name="groomers" v-model="shower_groomer">
                                    <option v-for="groomer in groomers" :key="groomer.id" :value="groomer.id">
                                        {{groomer.name}}</option>
                                    <option :value="null" disabled>Select a groomer</option>
                                </select>

                            </div>

                            <div class="row space_between service_assign_g" v-if="current_sess.medical_shower">
                                <div>medical shower</div>

                                <select name="groomers" v-model="medical_shower_groomer">
                                    <option v-for="groomer in groomers" :key="groomer.id" :value="groomer.id">
                                        {{groomer.name}}</option>
                                    <option :value="null" disabled>Select a groomer</option>

                                </select>

                            </div>

                            <div class="row space_between service_assign_g" v-if="current_sess.dry_shower">
                                <div>dry shower</div>

                                <select name="groomers" v-model="dry_shower_groomer">
                                    <option v-for="groomer in groomers" :key="groomer.id" :value="groomer.id">
                                        {{groomer.name}}</option>
                                    <option :value="null" disabled>Select a groomer</option>

                                </select>

                            </div>

                            <div class="row space_between service_assign_g" v-if="current_sess.hair_cut">
                                <div>hair cut</div>

                                <select name="groomers" v-model="hair_cut_groomer">
                                    <option v-for="groomer in groomers" :key="groomer.id" :value="groomer.id">
                                        {{groomer.name}}</option>
                                    <option :value="null" disabled>Select a groomer</option>

                                </select>

                            </div>

                            <div class="row space_between service_assign_g" v-if="current_sess.hair_trimming">
                                <div>hair trimming</div>

                                <select name="groomers" v-model="hair_trimming_groomer">
                                    <option v-for="groomer in groomers" :key="groomer.id" :value="groomer.id">
                                        {{groomer.name}}</option>
                                    <option :value="null" disabled>Select a groomer</option>

                                </select>

                            </div>

                            <div class="row space_between service_assign_g" v-if="current_sess.nail_trimming">
                                <div>nail trimming</div>

                                <select name="groomers" v-model="nail_trimming_groomer">
                                    <option v-for="groomer in groomers" :key="groomer.id" :value="groomer.id">
                                        {{groomer.name}}</option>
                                    <option :value="null" disabled>Select a groomer</option>

                                </select>

                            </div>

                            <div class="row space_between service_assign_g" v-if="current_sess.anal_gland">
                                <div>anal gland</div>

                                <select name="groomers" v-model="anal_gland_groomer">
                                    <option v-for="groomer in groomers" :key="groomer.id" :value="groomer.id">
                                        {{groomer.name}}</option>
                                    <option :value="null" disabled>Select a groomer</option>

                                </select>

                            </div>

                            <div class="err" v-if="multi_groomer_error !== null">{{ multi_groomer_error }}</div>

                            <div class="row remove_receipt_id_pop_up_btns_cont mr_top_15">
                                <button
                                    class="btn remove_receipt_id_pop_up_btn remove_receipt_id_pop_up_btn_cancel cencel_assign_groomers"
                                    @click="close_add_multiple_groomer()">Cancel</button>
                                <button
                                    class="btn btn_first_grooming delete_txt remove_receipt_id_pop_up_btn remove_receipt_id_pop_up_btn_remove "
                                    @click="add_multiple_groomer()">
                                    <div class="loading" v-if="multi_groomer_loading">
                                        <Spinner />
                                    </div>
                                    <div class="btn_txt" v-else>Save</div>
                                </button>
                            </div>
                        </div>

                    </div>


                </div>


                <hr v-if="current_sess.pet_type === 'dog' && company !== 'pets_club'">
                <div class="groomers" v-if="current_sess.pet_type === 'dog' && company !== 'pets_club'">
                    <div class="groomers_heading">Breed Size</div>
                    <div class="row groomers_names_cont">
                        <div :class="`${current_sess.giant === true ? 'groomer groomer_selected pointer' : 'groomer pointer'}`"
                            @click="select_breed_size(current_sess.giant)">
                            <spinner :black='true' v-if="breed_size_loading !== null && breed_size_loading === true">
                            </spinner>
                            <div v-else>
                                
                                <div >double coat / giant</div>
                                <!-- <div v-else>giant</div> -->
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>

        <div class="sess_info_cont" v-if="show_sess_edit">

            <div class=" sess_info">
                <div class="close_cont">
                    <div class="close" @click="close_edit()">close</div>
                </div>
                <!-- <hr> -->
                <div class="groomers">
                    <div class="groomers_heading">parent</div>
                    <input class="edit_cont_input" v-model="temp_sess_update.parent_name" type="text"
                        placeholder="parent name">
                    <input class="edit_cont_input edit_phone_input" v-model="temp_sess_update.parent_phone" type="tel"
                        placeholder="phone">
                </div>
                <hr>
                <div class="groomers">
                    <div class="groomers_heading no_mr">pet</div>
                    <div class="row pet_name_cont">

                        <input v-model="temp_sess_update.pet_name" class="edit_cont_input" type="text"
                            placeholder="pet name">
                        <div class="coulmn mr">
                            <div class="label" @click="choose_type('dog')">Dog</div>
                            <div @click="choose_type('dog')"
                                :class=" temp_sess_update.pet_type && temp_sess_update.pet_type === 'dog' ? 'label_img_cont selected' : 'label_img_cont' ">
                                <img class="label_img" src="@/assets/dog.svg">
                            </div>
                        </div>
                        <div class="coulmn">
                            <div class="label" @click="choose_type('cat')">Cat</div>
                            <div @click="choose_type('cat')"
                                :class=" temp_sess_update.pet_type && temp_sess_update.pet_type === 'cat' ? 'label_img_cont selected' : 'label_img_cont' ">
                                <img class="label_img" src="@/assets/cat.svg">
                            </div>
                        </div>
                    </div>


                    <div class="row pet_name_cont edit_cont">
                        <input class="edit_cont_input" v-model="temp_sess_update.pet_breed" type="text"
                            placeholder="breed">
                        <div class="column mr">
                            <div class="label" @click="choose_sex('male')">Male</div>
                            <div @click="choose_sex('male')"
                                :class=" temp_sess_update.pet_sex && temp_sess_update.pet_sex === 'male' ? 'label_img_cont selected' : 'label_img_cont' ">
                                <img class="label_img" src="@/assets/male.svg">
                            </div>
                        </div>
                        <div class="coulmn">
                            <div class="label" @click="choose_sex('female')">Female</div>
                            <div @click="choose_sex('female')"
                                :class="  temp_sess_update.pet_sex &&  temp_sess_update.pet_sex === 'female' ? 'label_img_cont selected' : 'label_img_cont' ">
                                <img class="label_img" src="@/assets/female.svg">
                            </div>
                        </div>
                    </div>


                    <input class="edit_cont_input edit_cont_input_date" v-model="temp_sess_update.pet_birthday"
                        type="date" placeholder="pet birthday">
                </div>
                <!-- <div class="error error_msg d_error_msg">error</div> -->
                <div class="error_msg d_error_msg" v-show="d_error">{{ d_error }}</div>

                <div class="row btns_cont">
                    <!-- <button class="btn back_btn">cencel</button> -->
                    <div></div>
                    <!-- <button class="btn btn_first_grooming">update</button> -->

                    <button
                        :class=" update_sess_loading ? 'btn btn_first_grooming no_padding' : 'btn btn_first_grooming' "
                        @click="update_sess()">
                        <div class="loading" v-if="update_sess_loading">
                            <Spinner />
                        </div>
                        <div class="btn_txt" v-else>Update</div>
                    </button>

                </div>
            </div>
        </div>


        <!-- show delete cont -->
        <div class="sess_info_cont" v-if="show_sess_delete">

            <div class=" sess_info">
                <div class="close_cont">
                    <div class="close" @click="close_delete()">close</div>
                </div>
                <!-- <div class="error error_msg d_error_msg">error</div> -->
                <div class="error_msg d_error_msg" v-show="d_d_error">{{ d_d_error }}</div>
                <div class="delete_title">
                    <div> are you sure you want to delete session number <b>{{ this.sessions.length -
                            this.current_sess_id }}</b> ?</div>
                </div>
                <div class="row btns_cont">
                    <!-- <button class="btn back_btn">cencel</button> -->

                    <!-- <button class="btn btn_first_grooming">update</button> -->
                    <div></div>

                    <button
                        :class=" delete_sess_loading ? 'btn btn_first_grooming delete_btn no_padding' : 'btn btn_first_grooming delete_btn' "
                        @click="delete_sess()">
                        <div class="loading" v-if="delete_sess_loading">
                            <Spinner />
                        </div>
                        <div class="btn_txt delete_txt" v-else>Delete</div>
                    </button>

                </div>
            </div>
        </div>



        <!-- show money cont -->
        <div class="sess_info_cont" v-if="show_money_info">

            <div class=" sess_info money_info">
                <div class="close_cont">
                    <div class="close" @click="close_money()">close</div>
                </div>
                <div v-if="company !== 'pets_club'">
                    <div
                        v-if=" typeof groomer_money === 'object' && groomer_money !== null && Object.keys(groomer_money).length > 0 ">
                        <div v-for="(money, grommer_name) in groomer_money" :key="grommer_name">
                            <p class="money_txt">
                                {{ grommer_name }} : {{money}}
                            </p>
                        </div>
                    </div>
                    <div v-else class="no_money">Can’t calculate commission — no sessions are finished yet.</div>
                </div>
                <div v-else class="pets_club_money">
                    <div
                        v-if=" pets_club_groomer_money && Array.isArray(pets_club_groomer_money) && pets_club_groomer_money.length > 0 ">
                        <div v-for="(v, i) in pets_club_groomer_money" :key="i">

                            <p class="money_txt" v-for="(money, grommer_name) in v" :key="grommer_name">
                                {{ grommer_name }} : {{money}}
                            </p>
                        </div>
                    </div>
                    <div v-else class="no_money">Can’t calculate commission — no sessions are finished yet.</div>
                </div>



            </div>
        </div>
        <AdminFooter></AdminFooter>
    </div>
</template>

<script>
// @ is an alias to /src
import request from '../axios_request';
import { mapState, mapActions } from 'vuex';
import SpinnerCircle from './SpinnerCircle.vue';
import Spinner from '@/components/Spinner.vue';
import VetHome from '@/components/VetHome.vue';
import AdminFooter from '@/components/AdminFooter.vue';
import dayjs from '../dayjs';
import SocketioService from '@/services/socketio.service.js';
import { useTimeAgo } from '@vueuse/core';
// import request from '../axios_request';

export default {

    name: 'AdminHome',
    components: {
        SpinnerCircle,
        Spinner,
        VetHome,
        AdminFooter
    },
    data: function () {
        return {
            page_loader: true,
            sessions: null,
            show_sess_info: false,
            groomers: null,
            groomer_id_loading: null,
            current_sess_id: null,
            status_: ['waiting', 'showering', 'finished', 'picked up', 'waiting outside', 'canceled'],
            status_txt_loading: null,
            breed_size_loading: null,
            show_money_info: false,
            timer: null,
            service_loading: null,
            show_sess_edit: false,
            temp_sess_update: null,
            update_sess_loading: false,
            d_error: null,
            show_sess_delete: false,
            d_d_error: null,
            delete_sess_loading: false,


            groomer_c_loading: false,
            groomer_t: null,
            groomer_c_err: null,
            groomer_c_good: false,

            service_t_loading: false,
            service_t: null,
            service_err: false,
            service_good: false,

            receipt_id: null,
            receipt_id_loading: false,
            receipt_id_loading_err: false,
            receipt_id_loading_good: null,
            remove_receipt_id_loading: false,
            remove_receipt_id_err: false,

            show_remove_receipt_id_pop_up: null,

            show_assign_multiple_groomers_window: false,
            multi_groomer_loading: false,
            multi_groomer_error: null,
            shower_groomer: null,
            medical_shower_groomer: null,
            dry_shower_groomer: null,
            hair_cut_groomer: null,
            hair_trimming_groomer: null,
            nail_trimming_groomer: null,
            anal_gland_groomer: null,

            show_add_another_phone_window: false,
            show_delete_new_phone_pop_up: null,
            show_edit_new_phone_window: false,
            new_phone_2: null,
            add_phone_to_all: false,
            add_new_phone_err: null,
            new_phone_loading: false,

            remove_phone_to_all: false,
            
            delete_new_phone_err: null,
            delete_new_phone_loading: false,

            update_phone_to_all: false,

            update_phone_2_var: null,
            update_phone_2_old_var: null,
            update_new_phone_err: null,
            update_new_phone_loading: false,


            super_username: null,
            super_password: null,
            super_role: null,
            super_company: null,
            super_branch: null,
            img: null,
            super_loading: false,
        }
    },
    mounted() {
        // this.logged_in;
        // 
        if( localStorage.getItem('token') ){
            var token = localStorage.getItem('token');
            request.post('/api/system/is_logged', {token})//, config
            .then((response)=>{
            // console.log(response);
                if( response.status === 200 ){
                    // console.log(response.data);
                    this.set_logged_in(true);
                    this.role_(response.data.role);
                    this.admin_name_(response.data.name);
                    this.company_(response.data.company);
                    this.receipt_number_feature_(response.data.receipt_number_feature);

                    console.log('-----------------',this.receipt_number_feature, response.data);

                    if( response.data.role === 'vet' ){
                        this.page_loader = false;
                        return;
                    }
                    if( response.data.role !== 'crew' || response.data.role !== 'super_admin' ){
                        if( response.data.role === 'customer' ){
                            this.$router.push({name: 'home'});
                        }
                    }
                    //load all sess
                    request.post('/api/session/get_all_today_sess')//, config
                    .then((sess_res) => {
                        // do the time thing
                        if( sess_res.data.length > 0 ){
                            sess_res.data.forEach((sess_) =>{
                                var old_created_at = sess_.createdAt;
                                sess_.createdAt = useTimeAgo(old_created_at);
                            });
                        }
                        this.sessions = sess_res.data;
                        console.log('sessions', this.sessions);
                        // console.log(sess_res.data);
                        // load all groomers
                        // this.page_loader = false;
                        request
                            .get('/api/groomer/get_all')//, config
                            .then((grommers_res) => {
                                this.groomers = grommers_res.data;
                                // console.log(grommers_res.data);
                                // load all groomers
                                
                                this.page_loader = false;
                            })
                            .catch((grommers_e) => {
                                console.log(grommers_e);
                                this.grommers_e = false;
                                this.page_loader = false;
                            });
                    })
                    .catch((sess_e) => {
                        console.log(sess_e);
                        this.sessions = '';
                        this.page_loader = false;
                    });
                    return;
                }
                //not logged
                this.set_logged_in(false);
                this.role_(null);
                localStorage.clear();
                this.$router.push({name: 'admin_login'});
            }).catch((e) => {
                console.log(e);
                this.set_logged_in(false);
                this.role_(null);
                localStorage.clear();
                this.$router.push({name: 'admin_login'});
            });

            /// use socket
            SocketioService.socket.on('new_session', (data) => {
                console.log(data);
                request.post('/api/session/get_all_today_sess')//, config
                    .then((sess_res) => {
                        // do the time thing
                        if( sess_res.data.length > 0 ){
                            sess_res.data.forEach((sess_) =>{
                                var old_created_at = sess_.createdAt;
                                sess_.createdAt = useTimeAgo(old_created_at);
                            });
                        }
                        this.sessions = sess_res.data;
                    })
                    .catch((sess_e) => {
                        console.log(sess_e);
                        this.sessions = '';
                    });
            });

            /// use socket
            SocketioService.socket.on('sess_update', (data) => {
                console.log('---------','---------');
                console.log(data);
                request.post('/api/session/get_all_today_sess')//, config
                    .then((sess_res) => {
                        // do the time thing
                        if( sess_res.data.length > 0 ){
                            sess_res.data.forEach((sess_) =>{
                                var old_created_at = sess_.createdAt;
                                sess_.createdAt = useTimeAgo(old_created_at);
                            });
                        }
                        this.sessions = sess_res.data;
                    })
                    .catch((sess_e) => {
                        console.log(sess_e);
                        this.sessions = '';
                    });
            });


        }else{
            this.set_logged_in(false);
            this.role_(null);
            localStorage.clear();
            this.$router.push({name: 'admin_login'});
        }


    },
    methods: {
        ...mapActions([
            "role_",
            "set_logged_in",
            'admin_name_',
            'company_',
            'receipt_number_feature_'
        ]),
        add_multiple_groomer(){

            if( this.multi_groomer_loading === true ){
                return;
            }

            this.multi_groomer_loading = true;
            this.multi_groomer_error = null;

            // get multi_groomers in json format
            var multi_groomers = [];

            //check shower
            if( this.current_sess.shower && this.current_sess.shower === true ){
                if( this.shower_groomer !== null ){
                    multi_groomers.push({
                        groomer: this.groomers.find(g => g.id === this.shower_groomer).name,
                        groomer_id: this.shower_groomer,
                        service: 'shower'
                    });
                }
            }

            //check medical_shower
            if( this.current_sess.medical_shower && this.current_sess.medical_shower === true ){
                if( this.medical_shower_groomer !== null ){
                    multi_groomers.push({
                        groomer: this.groomers.find(g => g.id === this.medical_shower_groomer).name,
                        groomer_id: this.medical_shower_groomer,
                        service: 'medical shower'
                    });
                }
            }

            //check dry_shower
            if( this.current_sess.dry_shower && this.current_sess.dry_shower === true ){
                if( this.dry_shower_groomer !== null ){
                    multi_groomers.push({
                        groomer: this.groomers.find(g => g.id === this.dry_shower_groomer).name,
                        groomer_id: this.dry_shower_groomer,
                        service: 'dry shower'
                    });
                }
            }

            //check hair_cut
            if( this.current_sess.hair_cut && this.current_sess.hair_cut === true ){
                if( this.hair_cut_groomer !== null ){
                    multi_groomers.push({
                        groomer: this.groomers.find(g => g.id === this.hair_cut_groomer).name,
                        groomer_id: this.hair_cut_groomer,
                        service: 'hair cut'
                    });
                }
            }

            //check hair_trimming
            if( this.current_sess.hair_trimming && this.current_sess.hair_trimming === true ){
                if( this.hair_trimming_groomer !== null ){
                    multi_groomers.push({
                        groomer: this.groomers.find(g => g.id === this.hair_trimming_groomer).name,
                        groomer_id: this.hair_trimming_groomer,
                        service: 'hair trimming'
                    });
                }
            }

            //check nail_trimming
            if( this.current_sess.nail_trimming && this.current_sess.nail_trimming === true ){
                if( this.nail_trimming_groomer !== null ){
                    multi_groomers.push({
                        groomer: this.groomers.find(g => g.id === this.nail_trimming_groomer).name,
                        groomer_id: this.nail_trimming_groomer,
                        service: 'nail trimming'
                    });
                }
            }

            //check anal_gland
            if( this.current_sess.anal_gland && this.current_sess.anal_gland === true ){
                if( this.anal_gland_groomer !== null ){
                    multi_groomers.push({
                        groomer: this.groomers.find(g => g.id === this.anal_gland_groomer).name,
                        groomer_id: this.anal_gland_groomer,
                        service: 'anal gland'
                    });
                }
            }


            console.log(multi_groomers);

            //check if multi_groomers is empty
            if( multi_groomers.length === 0 ){
                this.multi_groomer_loading = false;
                this.multi_groomer_error = 'you did not select any groomer.';
                //show error msg
                return;
            }

            //check if multi_groomers all service have groomer_id
            const firstGroomerId = multi_groomers[0]?.groomer_id;

            const allSameGroomerId = multi_groomers.every(item => item.groomer_id === firstGroomerId);

            console.log('allSameGroomerId', allSameGroomerId);





            var sess_id = this.current_sess.id;

            var missing_service = false;
            //convert multi_groomers to array then loop though the multi_groomers
            var sess_services = [];

            if( this.current_sess.shower ){
                sess_services.push('shower');
            }

            if( this.current_sess.medical_shower ){
                sess_services.push('medical shower');
            }

            if( this.current_sess.dry_shower ){
                sess_services.push('dry shower');
            }

            if( this.current_sess.hair_cut ){
                sess_services.push('hair cut');
            }

            if( this.current_sess.hair_trimming ){
                sess_services.push('hair trimming');
            }

            if( this.current_sess.nail_trimming ){
                sess_services.push('nail trimming');
            }

            if( this.current_sess.anal_gland ){
                sess_services.push('anal gland');
            }

            // check if any selected service not not included in multi_groomers
            for( var i = 0; i < sess_services.length; i++ ){
                var service = sess_services[i];
                // check if service is not included in multi_groomers
                if( multi_groomers.find(item => item.service === service) === undefined ){
                    missing_service = true;
                    break;
                }
            }


            var groomer_id = null;
            var groomer_name = null;

            console.log('missing_service', missing_service);

            if( allSameGroomerId === true && missing_service === false ){
                groomer_id = multi_groomers[0]?.groomer_id;
                groomer_name =  multi_groomers[0]?.groomer;
                multi_groomers =  null;
            }else{
                groomer_id = undefined;
                groomer_name = undefined;
            }



            request
                .post('/api/session/update', {
                    sess_id,
                    groomer_id,
                    groomer_name,
                    multi_groomers
                })//, config
                .then((sess_u) => {
                    console.log(sess_u);
                    //load the sess again
                    request
                        .post('/api/session/get_by_id', {
                            id: sess_id
                        })//, config
                        .then((sess_n) => {
                            // here
                            // this.current_sess = sess_n.data;
                            // do the time thing
                            var old_created_at = sess_n.data.createdAt;
                            sess_n.data.createdAt = useTimeAgo(old_created_at);

                            this.sessions[this.current_sess_id] = sess_n.data;
                            this.multi_groomer_loading = false;
                            this.multi_groomer_error = null;
                            this.close_add_multiple_groomer();
                        })
                        .catch((sess_n_err) => {
                            console.log(sess_n_err);
                            this.multi_groomer_loading = false;
                            //show error msg
                            this.multi_groomer_error = 'error #1n.';
                        });
                })
                .catch((sess_u_err) => {
                    console.log(sess_u_err);
                    this.multi_groomer_loading = false;
                    //show error msg
                    this.multi_groomer_error = 'error #2n.';
                });

        },
        open_add_multiple_groomer(){

            this.show_assign_multiple_groomers_window = true;
            this.multi_groomer_error = null;
            
            // check if session has groomer_id
            if( this.current_sess.groomer_id && this.current_sess.groomer_id !== null && this.current_sess.groomer_name && this.current_sess.groomer_name !== null ){
                this.shower_groomer = this.current_sess.groomer_id;
                this.medical_shower_groomer = this.current_sess.groomer_id;
                this.dry_shower_groomer = this.current_sess.groomer_id;
                this.hair_cut_groomer = this.current_sess.groomer_id;
                this.hair_trimming_groomer = this.current_sess.groomer_id;
                this.nail_trimming_groomer = this.current_sess.groomer_id;
                this.anal_gland_groomer = this.current_sess.groomer_id;
            }else{
                // check if session has multi_groomers
                if( this.current_sess.multi_groomers && this.current_sess.multi_groomers.length > 0 ){

                    const groomer_per_service = JSON.parse(this.current_sess.multi_groomers);

                    this.shower_groomer = this.getGroomerIdByService(groomer_per_service, 'shower');
                    this.medical_shower_groomer = this.getGroomerIdByService(groomer_per_service, 'medical shower');
                    this.dry_shower_groomer = this.getGroomerIdByService(groomer_per_service, 'dry shower');
                    this.hair_cut_groomer = this.getGroomerIdByService(groomer_per_service, 'hair cut');
                    this.hair_trimming_groomer = this.getGroomerIdByService(groomer_per_service, 'hair trimming');
                    this.nail_trimming_groomer = this.getGroomerIdByService(groomer_per_service, 'nail trimming');
                    this.anal_gland_groomer = this.getGroomerIdByService(groomer_per_service, 'anal gland');
                    
                }else{
                    this.shower_groomer = null;
                    this.medical_shower_groomer = null;
                    this.dry_shower_groomer = null;
                    this.hair_cut_groomer = null;
                    this.hair_trimming_groomer = null;
                    this.nail_trimming_groomer = null;
                    this.anal_gland_groomer = null;
                }
            }
        },

        getGroomerIdByService(multi_groomers_obj, serviceName) {
            const result = multi_groomers_obj.find(item => item.service === serviceName);
            return result ? result.groomer_id : null;
        },

        close_add_multiple_groomer(){
            this.show_assign_multiple_groomers_window = false;
            this.multi_groomer_error = null;
        },

        add_receipt_id(){
            if( this.receipt_id_loading === true ){
                return;
            }
            this.receipt_id_loading = true;
            this.receipt_id_loading_err = false;
            this.receipt_id_loading_good = null;
            
            //return if receipt_id is empty or not number
            if( this.receipt_id === null || isNaN(this.receipt_id) ){
                this.receipt_id_loading = false;
                this.receipt_id_loading_err = 'receipt number only accept numbers.';
                return;
            }

            var id = this.current_sess.id;
            var receipt_id = this.receipt_id;
            request
                .post('/api/session/add_receipt_id', {
                    id,
                    receipt_id
                })//, config
                .then((d) => {
                    console.log(d, id, receipt_id);
                    if( d && d.status === 200 ){
                        this.receipt_id_loading = false;
                        this.receipt_id_loading_err = false;
                        this.receipt_id_loading_good = d.data.msg;
                        setTimeout(() => {
                            this.receipt_id_loading_good = null;
                        }, 3000);
                        if(this.receipt_id_loading_good !== 'already exist.'){
                            this.receipt_id = null;
                        }
                    }
                })
                .catch((sess_n_err) => {
                    console.log(sess_n_err);
                    this.receipt_id_loading = false;
                    this.receipt_id_loading_err = true;
                });
        },
        add_service_total(){
            if( this.service_t_loading === true ){
                return;
            }
            this.service_t_loading = true;
            this.service_err = false;
            this.service_good = false;

            var id = this.current_sess.id;
            var t = this.service_t;
            request
                .post('/api/session/add_services_total', {
                    id,
                    services_total: t
                })//, config
                .then((d) => {
                    if( d && d.status === 200 ){
                        this.service_t_loading = false;
                        this.service_err = false; 
                        this.service_good = true;
                    }

                })
                .catch((sess_n_err) => {
                    console.log(sess_n_err);
                    this.service_t_loading = false;
                    this.service_err = true;
                });
        },
        add_groomer_total(){
            if( this.groomer_c_loading === true ){
                return;
            }

            if( !this.current_sess.groomer_name || this.current_sess.groomer_name === null ){
                this.groomer_c_loading = false;
                this.groomer_c_err = 'no groomer selected.';
                console.log('groomer not selected');
                return;
            }

            this.groomer_c_loading = true;
            this.groomer_c_err = null;
            this.groomer_c_good = false;

            var id = this.current_sess.id;
            var t = this.groomer_t;
            request
                .post('/api/session/add_groomer_commission', {
                    id,
                    groomer_commission: t
                })//, config
                .then((d) => {
                    if( d && d.status === 200 ){
                        this.groomer_c_loading = false;
                        this.groomer_c_err = null;
                        this.groomer_c_good = true;
                    }
                })
                .catch((sess_n_err) => {
                    console.log(sess_n_err);
                    this.groomer_c_loading = false;
                    this.groomer_c_err = 'error';
                });
        },
        useTimeAgo_(d){
            var txt = useTimeAgo(d);
            console.log(txt);
            return txt;
        },
        time_(t) {
            return dayjs(t).fromNow(false);
        },
        make_undersocre(txt){
            // var newStr = str.split(" ").join("_");
            return txt.split(" ").join("_");
        },

        is_paid(index){
            // console.log('--=---=-=-=-', JSON.parse(this.sessions[index].receipts_id));
            // check if session is object
            if( this.sessions[index] ){
                // check if session has paid
                if( this.sessions[index].receipts_id && this.sessions[index].receipts_id !== null && this.sessions[index].receipts_id.length > 0 && JSON.parse(this.sessions[index].receipts_id).length > 0 ){
                    return true;
                }else{
                    return false;
                }
            }
            return false;
            // console.log('--=---=-=-=-', this.sessions[index].receipts_id[0]);
            // console.log('index', index);
            // return true;
        },

        single_or_multi_phone_txt(sess){
            // check if session is object
            if( sess !== null && typeof sess === 'object' ){

                if( sess.phones && sess.phones !== null && Array.from(JSON.parse(sess.phones)).length > 0 ){

                    return ',..';
                }

            }
            return null;
        },

        show_check_box(){
            // check if session is object

            if( this.current_sess !== null && typeof this.current_sess === 'object' ){

                // if( this.current_sess.parent_phone && this.current_sess.phones !== null && Array.from(JSON.parse(this.current_sess.phones)).length > 1 ){
                //     return true;
                // }

                // search if sesstions with this.current_sess.parent_phone more then 1
                var count = 0;
                for( var i = 0; i < this.sessions.length; i++ ){
                    if( this.sessions[i].parent_phone && this.sessions[i].parent_phone === this.current_sess.parent_phone ){
                        count++;
                    }
                }

                if( count > 1 ){
                    return true;
                }

            }
            return false;
        },

        single_or_multi_groomer(session){
            // check if session is object
            if( typeof session === 'object' && session !== null ){
                // check if session has groomer_id
                if( session.groomer_id && session.groomer_id !== null && session.groomer_name && session.groomer_name !== null ){
                    return session.groomer_name;
                }else{
                    // check if session has multi_groomers
                    if( session.multi_groomers && session.multi_groomers.length > 0 ){
                        // var groomer_names = JSON.parse(session.multi_groomers).map(g => g.groomer).join(', ');

                        var data = JSON.parse(session.multi_groomers);

                        let groomers = new Set();
                        for (let item of data) {
                            groomers.add(item.groomer);
                        }

                        const groomer_names = [...groomers].join(", ");

                        return groomer_names;
                    }else{
                        return null;
                    }
                }
            }
            return null;
        },

        groomer_class(id){
            // `${groomer.id === current_sess.groomer_id ? 'groomer groomer_selected' : 'groomer'}`
            var groomer_class = 'groomer';

            if( this.current_sess.groomer_id && this.current_sess.groomer_id !== null && this.current_sess.groomer_id === id ){

                groomer_class = 'groomer groomer_selected';
            }else if( this.current_sess.multi_groomers && this.current_sess.multi_groomers.length > 0 ){
                const groomer_per_service = JSON.parse(this.current_sess.multi_groomers).find(item => item.groomer_id === id);
                if( groomer_per_service && groomer_per_service.groomer_id && groomer_per_service.groomer_id === id ){
                    groomer_class = 'groomer groomer_selected_multi';
                }else{
                    groomer_class = 'groomer';
                }
            }
            return groomer_class;
        },

        is_sess_missing_groomer(sess_id_){
            
            if( this.sessions && this.sessions[sess_id_] ){
                if( ['waiting', 'waiting outside', 'canceled'].includes(this.sessions[sess_id_].status) ){
                    return false;
                }
                // herrre
                if( this.sessions[sess_id_] && this.sessions[sess_id_].groomer_id ){
                    return false;
                }else if( this.sessions[sess_id_] && this.sessions[sess_id_].multi_groomers && this.sessions[sess_id_].multi_groomers.length > 0 ){
                    const groomer_per_service = JSON.parse(this.sessions[sess_id_].multi_groomers).find(item => item.groomer_id === null);
                    //check if any selected service not not included in multi_groomers
                    var no_missing_service = false;
                    //convert multi_groomers to array then loop though the multi_groomers
                    var parsed_multi_groomers = JSON.parse(this.sessions[sess_id_].multi_groomers);
                    var sess_services = [];

                    if( this.sessions[sess_id_].shower ){
                        sess_services.push('shower');
                    }

                    if( this.sessions[sess_id_].medical_shower ){
                        sess_services.push('medical shower');
                    }

                    if( this.sessions[sess_id_].dry_shower ){
                        sess_services.push('dry shower');
                    }

                    if( this.sessions[sess_id_].hair_cut ){
                        sess_services.push('hair cut');
                    }

                    if( this.sessions[sess_id_].hair_trimming ){
                        sess_services.push('hair trimming');
                    }

                    if( this.sessions[sess_id_].nail_trimming ){
                        sess_services.push('nail trimming');
                    }

                    if( this.sessions[sess_id_].anal_gland ){
                        sess_services.push('anal gland');
                    }

                    // check if any selected service not not included in multi_groomers
                    for( var i = 0; i < sess_services.length; i++ ){
                        var service = sess_services[i];
                        // check if service is not included in multi_groomers
                        if( parsed_multi_groomers.find(item => item.service === service) === undefined ){
                            no_missing_service = true;
                            break;
                        }
                    }
                    console.log('groomer_per_service', groomer_per_service, no_missing_service);
                    if( !groomer_per_service && no_missing_service === false ){
                        console.log('no groomer id or name');
                        return false;
                    }else{
                        return true;
                    }
                }
            }
            return true;
        },

        check_service_groomer(session, service){
            // check if session is object
            if( typeof session === 'object' && session !== null ){
                // check if session has groomer_id
                if( session.groomer_id && session.groomer_id !== null && session.groomer_name && session.groomer_name !== null ){
                    return session.groomer_id;
                }else{
                    // check if session has multi_groomers
                    if( session.multi_groomers && session.multi_groomers.length > 0 ){

                        const result =  JSON.parse(session.multi_groomers).find(item => item.service === service);
                        return result ? result.groomer_id : null;
                    }else{
                        console.log('no groomer id or name');
                        return null;
                    }
                }
            }
            return null;
        },
        table_num(i){
            // if( i === 0 ){
            //     return this.sessions.length;
            // }else if( (i + 1) === this.sessions.length ){
            //     return 1;
            // }else{
            //     return i + 1;
            // }
            return this.sessions.length - i;
        },
        birthday(t){
            var today = new Date();
            var birthDate = new Date(t);
            var age = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();
            console.log(m);
            age = age * 12 + m;
            if( age === 0 ){
                const diffInMs   = today - birthDate;
                const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
                return diffInDays;
            }else{
                return age;
            }
        },
        manage_btn(i){
            
            this.show_sess_info = true;
            this.current_sess_id = i;
            console.log(this.current_sess);
            this.service_t = this.current_sess.services_total;
            this.service_err = false;
            this.service_good = false;

            this.groomer_t = this.current_sess.groomer_commission;
            this.groomer_c_err = null;
            this.groomer_c_good = false;

            this.receipt_id_loading_err = false;
            this.receipt_id_loading_good = null;

           // just testing (u must convert 'this.current_sess.receipts_id' to array)
            console.log(this.current_sess.receipts_id);
        },
        close(){
            this.show_sess_info = false;
            this.current_sess_id = null;
            this.receipt_id = null;
        },
        

        open_add_new_phone(){
            this.show_add_another_phone_window = true;
            this.add_new_phone_err = null;
        },
        close_add_new_phone(){
            this.new_phone_2 = null;
            this.add_phone_to_all = false;
            this.add_new_phone_err = null;
            this.show_add_another_phone_window = false;
        },
        add_new_phone(){
            console.log('add_new_phone', this.new_phone_2, this.add_phone_to_all);
            if( this.new_phone_2 === null || this.new_phone_2 === '' ){
                this.add_new_phone_err = 'phone number is required.';
                return;
            }else if( this.new_phone_2.length < 8 ){
                this.add_new_phone_err = 'phone number must be at least 8 characters.';
                return;
            }else{
                this.add_new_phone_err = null;
                this.new_phone_loading = true;
                // var { sess_id, phone, add_to_all, main_phone } = req.body;
                //send to server
                request
                    .post('/api/session/add_more_phones', {
                        sess_id: this.current_sess.id,
                        phone: this.new_phone_2,
                        add_to_all: this.add_phone_to_all,
                        main_phone: this.current_sess.parent_phone
                    })//, config
                    .then((d) => {
                        console.log(d);
                        if( d && d.status === 200 ){
                            this.add_new_phone_err = null;
                            // this.d_good = true;
                            // setTimeout(() => {
                            //     this.d_good = null;
                            // }, 3000);
                            this.new_phone_2 = null;
                            this.add_phone_to_all = false;
                            this.close_add_new_phone();
                            this.new_phone_loading = false;
                        }
                    })
                    .catch((sess_n_err) => {
                        console.log(sess_n_err);
                        this.add_new_phone_err = 'something went wrong x#8.';
                        this.new_phone_loading = false;
                    });
            }
                
        },


        open_edit_new_phone(phone, i){
            console.log(phone, i);
            this.update_phone_2_old_var = phone;
            this.update_phone_2_var = phone;
            this.show_edit_new_phone_window = true;
            this.update_new_phone_err = null;
        },
        close_edit_new_phone(){
            this.show_edit_new_phone_window = false;
            this.update_phone_2_var = null;
            this.update_new_phone_err = null;
        },
        update_new_phone(){
            console.log('update_new_phone', this.update_phone_2_var, this.update_phone_2_old_var, this.update_phone_to_all);

            // this.new_phone_2 = null;
            // this.add_phone_to_all = false;
            // this.show_add_another_phone_window = false;

            // both the same
            if( this.update_phone_2_var === this.update_phone_2_old_var ){
                this.update_new_phone_err = 'phone number is the same.';
                return;
            }

            if( this.update_phone_2_var === null || this.update_phone_2_var === '' ){
                this.update_new_phone_err = 'phone number is required.';
                return;
            }else if( this.update_phone_2_var.length < 8 ){
                this.update_new_phone_err = 'phone number must be at least 8 characters.';
                return;
            }else{
                this.update_new_phone_err = null;
                this.update_new_phone_loading = true;
                // var { sess_id, phone, add_to_all, main_phone } = req.body;
                //send to server
                request
                    .post('/api/session/update_more_phones', {

                        sess_id: this.current_sess.id,
                        phone: this.update_phone_2_old_var,
                        new_phone: this.update_phone_2_var,
                        update_to_all: this.update_phone_to_all,
                        main_phone: this.current_sess.parent_phone
                    })//, config
                    .then((d) => {
                        console.log(d);
                        if( d && d.status === 200 ){
                            this.update_new_phone_err = null;
                            // this.d_good = true;
                            // setTimeout(() => {
                            //     this.d_good = null;
                            // }, 3000);
                            this.update_phone_2_var = null;
                            this.update_phone_to_all = false;
                            this.close_edit_new_phone();
                            this.update_new_phone_loading = false;
                        }
                    })
                    .catch((sess_n_err) => {
                        console.log(sess_n_err);
                        this.update_new_phone_err = 'something went wrong x#0.';
                        this.update_new_phone_loading = false;
                    });
            }


        },



        open_delete_phone(phone, i){
            console.log(phone, i);
            this.show_delete_new_phone_pop_up = phone;
            this.delete_new_phone_err = null;
        },
        close_delete_phone(){
            this.show_delete_new_phone_pop_up = null;
            this.delete_new_phone_err = null;
        },
        delete_new_phone(){

            if( this.show_delete_new_phone_pop_up === null ){
                this.delete_new_phone_err = 'choose phone number to delete.';
                return;
            }

            if( this.delete_new_phone_loading === true ){
                return;
            }

                this.delete_new_phone_err = null;
                this.delete_new_phone_loading = true;
                // var { sess_id, phone, add_to_all, main_phone } = req.body;
                //send to server

                request
                    .post('/api/session/delete_new_phone', {
                        sess_id: this.current_sess.id,
                        phone: this.show_delete_new_phone_pop_up,
                        delete_from_all: this.remove_phone_to_all,
                        main_phone: this.current_sess.parent_phone
                    })//, config
                    .then((d) => {
                        console.log(d);
                        if( d && d.status === 200 ){
                            this.delete_new_phone_err = null;
                            this.remove_phone_to_all = false;
                            this.close_delete_phone();
                            this.delete_new_phone_loading = false;
                        }
                    })
                    .catch((sess_n_err) => {
                        console.log(sess_n_err);
                        this.delete_new_phone_err = 'error deleting phone number #e0.';
                        this.delete_new_phone_loading = false;
                    });
            
            
        },



        select_groomer(id, name){
            if( this.groomer_id_loading !== null ){
                return;
            }
            var sess_id = this.current_sess.id;
            this.groomer_id_loading = id;
            if( this.groomer_id_loading === this.current_sess.groomer_id ){
                console.log('already me.');
                this.groomer_id_loading = null;
                return;
            }



            request
                .post('/api/session/update', {
                    sess_id,
                    groomer_id: id,
                    groomer_name: name
                })//, config
                .then((sess_u) => {
                    console.log(sess_u);
                    //load the sess again
                    request
                        .post('/api/session/get_by_id', {
                            id: sess_id
                        })//, config
                        .then((sess_n) => {
                            // here
                            // this.current_sess = sess_n.data;
                            // do the time thing
                            var old_created_at = sess_n.data.createdAt;
                            sess_n.data.createdAt = useTimeAgo(old_created_at);

                            this.sessions[this.current_sess_id] = sess_n.data;
                            this.groomer_id_loading = null;
                        })
                        .catch((sess_n_err) => {
                            console.log(sess_n_err);
                            this.groomer_id_loading = null;
                        });
                })
                .catch((sess_u_err) => {
                    console.log(sess_u_err);
                    this.groomer_id_loading = null;
                });
        },
        select_status(status){
            console.log(status);
            if( this.status_txt_loading !== null ){
                return;
            }
            var sess_id = this.current_sess.id;
            this.status_txt_loading = status;
            if( this.status_txt_loading === this.current_sess.status ){
                console.log('already same status.');
                this.status_txt_loading = null;
                return;
            }



            request
                .post('/api/session/update', {
                    sess_id,
                    status
                })//, config
                .then((sess_u) => {
                    console.log(sess_u);
                    //load the sess again
                    request
                        .post('/api/session/get_by_id', {
                            id: sess_id
                        })//, config
                        .then((sess_n) => {
                            // here
                            // this.current_sess = sess_n.data;
                            // do the time thing
                            var old_created_at = sess_n.data.createdAt;
                            sess_n.data.createdAt = useTimeAgo(old_created_at);
                            this.sessions[this.current_sess_id] = sess_n.data;
                            this.status_txt_loading = null;
                        })
                        .catch((sess_n_err) => {
                            console.log(sess_n_err);
                            this.status_txt_loading = null;
                        });
                })
                .catch((sess_u_err) => {
                    console.log(sess_u_err);
                    this.status_txt_loading = null;
                });
        },
        select_service(service){
            var sess_id = this.current_sess.id;
            console.log(service, this.current_sess, this.company);
            if( this.service_loading === null ){
                

                // shower select
                if( service === 'shower' && this.current_sess.shower === false ){
                    this.service_loading = service;
                    //deselct medi
                    //and select shower
                    console.log(1);
                    request
                        .post('/api/session/update', {
                            sess_id,
                            service
                        })//, config
                        .then((sess_u) => {
                            console.log(sess_u);
                            //load the sess again
                            request
                                .post('/api/session/get_by_id', {
                                    id: sess_id
                                })//, config
                                .then((sess_n) => {
                                    // here
                                    // this.current_sess = sess_n.data;
                                    // do the time thing
                                    var old_created_at = sess_n.data.createdAt;
                                    sess_n.data.createdAt = useTimeAgo(old_created_at);
                                    this.sessions[this.current_sess_id] = sess_n.data;
                                    this.service_loading = null;
                                })
                                .catch((sess_n_err) => {
                                    console.log(sess_n_err);
                                    this.service_loading = null;
                                });
                        })
                        .catch((sess_u_err) => {
                            console.log(sess_u_err);
                            this.service_loading = null;
                        });

                //remove shower
                }else if( service === 'shower' && this.current_sess.shower === true ){
                    //['shower', 'medical_shower', 'dry_shower', 'hair_cut', 'hair_trimming', 'nail_trimming', 'anal_gland']
                    if(
                        this.current_sess.medical_shower === true ||
                        this.current_sess.dry_shower === true ||
                        this.current_sess.chemical_shower === true ||
                        this.current_sess.hair_cut === true ||
                        this.current_sess.hair_trimming === true ||
                        this.current_sess.nail_trimming === true ||
                        this.current_sess.anal_gland === true
                    ){

                        this.service_loading = service;
                        var service_r = service;

                        request
                                .post('/api/session/update', {
                                    sess_id,
                                    service_r
                                })//, config
                                .then((sess_u) => {
                                    console.log(sess_u);
                                    //load the sess again
                                    request
                                        .post('/api/session/get_by_id', {
                                            id: sess_id
                                        })//, config
                                        .then((sess_n) => {
                                            // here
                                            // this.current_sess = sess_n.data;
                                            // do the time thing
                                            var old_created_at = sess_n.data.createdAt;
                                            sess_n.data.createdAt = useTimeAgo(old_created_at);
                                            this.sessions[this.current_sess_id] = sess_n.data;
                                            this.service_loading = null;
                                        })
                                        .catch((sess_n_err) => {
                                            console.log(sess_n_err);
                                            this.service_loading = null;
                                        });
                                })
                                .catch((sess_u_err) => {
                                    console.log(sess_u_err);
                                    this.service_loading = null;
                                });


                    }
                }else if( service === 'medical_shower' && this.current_sess.medical_shower === false ){
                    this.service_loading = service;
                    //deselct shower
                    //and select medical_shower
                    request
                        .post('/api/session/update', {
                            sess_id,
                            service
                        })//, config
                        .then((sess_u) => {
                            console.log(sess_u);
                            //load the sess again
                            request
                                .post('/api/session/get_by_id', {
                                    id: sess_id
                                })//, config
                                .then((sess_n) => {
                                    // here
                                    // this.current_sess = sess_n.data;
                                    // do the time thing
                                    var old_created_at = sess_n.data.createdAt;
                                    sess_n.data.createdAt = useTimeAgo(old_created_at);
                                    this.sessions[this.current_sess_id] = sess_n.data;
                                    this.service_loading = null;
                                })
                                .catch((sess_n_err) => {
                                    console.log(sess_n_err);
                                    this.service_loading = null;
                                });
                        })
                        .catch((sess_u_err) => {
                            console.log(sess_u_err);
                            this.service_loading = null;
                        });

                //remove medical_shower
                }else if( service === 'medical_shower' && this.current_sess.medical_shower === true ){
                    //['shower', 'medical_shower', 'hair_cut', 'hair_trimming', 'nail_trimming', 'anal_gland']
                    if(  
                        this.current_sess.shower === true ||
                        this.current_sess.dry_shower === true ||
                        this.current_sess.chemical_shower === true ||
                        this.current_sess.hair_cut === true ||
                        this.current_sess.hair_trimming === true ||
                        this.current_sess.nail_trimming === true ||
                        this.current_sess.anal_gland === true
                    ){

                        this.service_loading = service;
                        service_r = service;

                        request
                                .post('/api/session/update', {
                                    sess_id,
                                    service_r
                                })//, config
                                .then((sess_u) => {
                                    console.log(sess_u);
                                    //load the sess again
                                    request
                                        .post('/api/session/get_by_id', {
                                            id: sess_id
                                        })//, config
                                        .then((sess_n) => {
                                            // here
                                            // this.current_sess = sess_n.data;
                                            // do the time thing
                                            var old_created_at = sess_n.data.createdAt;
                                            sess_n.data.createdAt = useTimeAgo(old_created_at);
                                            this.sessions[this.current_sess_id] = sess_n.data;
                                            this.service_loading = null;
                                        })
                                        .catch((sess_n_err) => {
                                            console.log(sess_n_err);
                                            this.service_loading = null;
                                        });
                                })
                                .catch((sess_u_err) => {
                                    console.log(sess_u_err);
                                    this.service_loading = null;
                                });


                    }
                    
   
                }else if( service === 'chemical_shower' && this.current_sess.chemical_shower === false && this.company === 'pets_club' ){
                    this.service_loading = service;
                    //deselct medi
                    //and select shower
                    console.log('xxxxxxxxxxxxxxxxx');
                    request
                        .post('/api/session/update', {
                            sess_id,
                            service
                        })//, config
                        .then((sess_u) => {
                            console.log(sess_u);
                            //load the sess again
                            request
                                .post('/api/session/get_by_id', {
                                    id: sess_id
                                })//, config
                                .then((sess_n) => {
                                    // here
                                    // this.current_sess = sess_n.data;
                                    // do the time thing
                                    var old_created_at = sess_n.data.createdAt;
                                    sess_n.data.createdAt = useTimeAgo(old_created_at);
                                    this.sessions[this.current_sess_id] = sess_n.data;
                                    this.service_loading = null;
                                })
                                .catch((sess_n_err) => {
                                    console.log(sess_n_err);
                                    this.service_loading = null;
                                });
                        })
                        .catch((sess_u_err) => {
                            console.log(sess_u_err);
                            this.service_loading = null;
                        });

                //remove shower
                }else if( service === 'chemical_shower' && this.current_sess.chemical_shower === true && this.company === 'pets_club' ){
                    console.log('tessst', this.current_sess.chemical_shower);
                    //['shower', 'medical_shower', 'hair_cut', 'hair_trimming', 'nail_trimming', 'anal_gland']
                    if(  this.current_sess.shower === true || 
                    this.current_sess.medical_shower === true ||
                    this.current_sess.dry_shower === true ||
                    this.current_sess.hair_cut === true ||
                    this.current_sess.hair_trimming === true ||
                    this.current_sess.nail_trimming === true ||
                    this.current_sess.anal_gland === true){

                        this.service_loading = service;
                        service_r = service;

                        request
                                .post('/api/session/update', {
                                    sess_id,
                                    service_r
                                })//, config
                                .then((sess_u) => {
                                    console.log(sess_u);
                                    //load the sess again
                                    request
                                        .post('/api/session/get_by_id', {
                                            id: sess_id
                                        })//, config
                                        .then((sess_n) => {
                                            // here
                                            // this.current_sess = sess_n.data;
                                            // do the time thing
                                            var old_created_at = sess_n.data.createdAt;
                                            sess_n.data.createdAt = useTimeAgo(old_created_at);
                                            this.sessions[this.current_sess_id] = sess_n.data;
                                            this.service_loading = null;
                                        })
                                        .catch((sess_n_err) => {
                                            console.log(sess_n_err);
                                            this.service_loading = null;
                                        });
                                })
                                .catch((sess_u_err) => {
                                    console.log(sess_u_err);
                                    this.service_loading = null;
                                });


                    }
                
                
                }
                
                else if( service === 'dry_shower' && this.current_sess.dry_shower === false && this.company !== 'pets_club' ){
                    this.service_loading = service;
                    //deselct medi
                    //and select shower
                    console.log('xxxxxxxxxxxxxxxxx');
                    request
                        .post('/api/session/update', {
                            sess_id,
                            service
                        })//, config
                        .then((sess_u) => {
                            console.log(sess_u);
                            //load the sess again
                            request
                                .post('/api/session/get_by_id', {
                                    id: sess_id
                                })//, config
                                .then((sess_n) => {
                                    // here
                                    // this.current_sess = sess_n.data;
                                    // do the time thing
                                    var old_created_at = sess_n.data.createdAt;
                                    sess_n.data.createdAt = useTimeAgo(old_created_at);
                                    this.sessions[this.current_sess_id] = sess_n.data;
                                    this.service_loading = null;
                                })
                                .catch((sess_n_err) => {
                                    console.log(sess_n_err);
                                    this.service_loading = null;
                                });
                        })
                        .catch((sess_u_err) => {
                            console.log(sess_u_err);
                            this.service_loading = null;
                        });

                //remove shower
                }else if( service === 'dry_shower' && this.current_sess.dry_shower === true && this.company === 'ziggy_pupps' ){
                    //['shower', 'medical_shower', 'hair_cut', 'hair_trimming', 'nail_trimming', 'anal_gland']
                    if(  this.current_sess.shower === true || 
                    this.current_sess.medical_shower === true ||
                    this.current_sess.chemical_shower === true ||
                    this.current_sess.hair_cut === true ||
                    this.current_sess.hair_trimming === true ||
                    this.current_sess.nail_trimming === true ||
                    this.current_sess.anal_gland === true){

                        this.service_loading = service;
                        service_r = service;

                        request
                                .post('/api/session/update', {
                                    sess_id,
                                    service_r
                                })//, config
                                .then((sess_u) => {
                                    console.log(sess_u);
                                    //load the sess again
                                    request
                                        .post('/api/session/get_by_id', {
                                            id: sess_id
                                        })//, config
                                        .then((sess_n) => {
                                            // here
                                            // this.current_sess = sess_n.data;
                                            // do the time thing
                                            var old_created_at = sess_n.data.createdAt;
                                            sess_n.data.createdAt = useTimeAgo(old_created_at);
                                            this.sessions[this.current_sess_id] = sess_n.data;
                                            this.service_loading = null;
                                        })
                                        .catch((sess_n_err) => {
                                            console.log(sess_n_err);
                                            this.service_loading = null;
                                        });
                                })
                                .catch((sess_u_err) => {
                                    console.log(sess_u_err);
                                    this.service_loading = null;
                                });


                    }
                
                
                }else if( service === 'hair_cut' && this.current_sess.hair_cut === false ){
                    this.service_loading = service;
                    //deselct hair_trimming
                    //and select hair_cut
                    request
                        .post('/api/session/update', {
                            sess_id,
                            service
                        })//, config
                        .then((sess_u) => {
                            console.log(sess_u);
                            //load the sess again
                            request
                                .post('/api/session/get_by_id', {
                                    id: sess_id
                                })//, config
                                .then((sess_n) => {
                                    // here
                                    // this.current_sess = sess_n.data;
                                    // do the time thing
                                    var old_created_at = sess_n.data.createdAt;
                                    sess_n.data.createdAt = useTimeAgo(old_created_at);
                                    this.sessions[this.current_sess_id] = sess_n.data;
                                    this.service_loading = null;
                                })
                                .catch((sess_n_err) => {
                                    console.log(sess_n_err);
                                    this.service_loading = null;
                                });
                        })
                        .catch((sess_u_err) => {
                            console.log(sess_u_err);
                            this.service_loading = null;
                        });

                //remove hair_cut
                }else if( service === 'hair_cut' && this.current_sess.hair_cut === true ){
                    //['shower', 'medical_shower', 'hair_cut', 'hair_trimming', 'nail_trimming', 'anal_gland']
                    if(  this.current_sess.shower === true || 
                    this.current_sess.medical_shower === true ||
                    this.current_sess.dry_shower === true ||
                    this.current_sess.chemical_shower === true ||
                    this.current_sess.hair_trimming === true ||
                    this.current_sess.nail_trimming === true ||
                    this.current_sess.anal_gland === true){

                        this.service_loading = service;
                        service_r = service;

                        request
                                .post('/api/session/update', {
                                    sess_id,
                                    service_r
                                })//, config
                                .then((sess_u) => {
                                    console.log(sess_u);
                                    //load the sess again
                                    request
                                        .post('/api/session/get_by_id', {
                                            id: sess_id
                                        })//, config
                                        .then((sess_n) => {
                                            // here
                                            // this.current_sess = sess_n.data;
                                            // do the time thing
                                            var old_created_at = sess_n.data.createdAt;
                                            sess_n.data.createdAt = useTimeAgo(old_created_at);
                                            this.sessions[this.current_sess_id] = sess_n.data;
                                            this.service_loading = null;
                                        })
                                        .catch((sess_n_err) => {
                                            console.log(sess_n_err);
                                            this.service_loading = null;
                                        });
                                })
                                .catch((sess_u_err) => {
                                    console.log(sess_u_err);
                                    this.service_loading = null;
                                });


                    }
                }else if( service === 'hair_trimming' && this.current_sess.hair_trimming === false ){
                    this.service_loading = service;
                    //deselct hair_cut
                    //and select hair_trimming
                    request
                        .post('/api/session/update', {
                            sess_id,
                            service
                        })//, config
                        .then((sess_u) => {
                            console.log(sess_u);
                            //load the sess again
                            request
                                .post('/api/session/get_by_id', {
                                    id: sess_id
                                })//, config
                                .then((sess_n) => {
                                    // here
                                    // this.current_sess = sess_n.data;
                                    // do the time thing
                                    var old_created_at = sess_n.data.createdAt;
                                    sess_n.data.createdAt = useTimeAgo(old_created_at);
                                    this.sessions[this.current_sess_id] = sess_n.data;
                                    this.service_loading = null;
                                })
                                .catch((sess_n_err) => {
                                    console.log(sess_n_err);
                                    this.service_loading = null;
                                });
                        })
                        .catch((sess_u_err) => {
                            console.log(sess_u_err);
                            this.service_loading = null;
                        });

                //remove hair_trimming
                }else if( service === 'hair_trimming' && this.current_sess.hair_trimming === true ){
                    //['shower', 'medical_shower', 'hair_cut', 'hair_trimming', 'nail_trimming', 'anal_gland']
                    if(  this.current_sess.shower === true || 
                    this.current_sess.medical_shower === true ||
                    this.current_sess.dry_shower === true ||
                    this.current_sess.chemical_shower === true ||
                    this.current_sess.hair_cut === true ||
                    this.current_sess.nail_trimming === true ||
                    this.current_sess.anal_gland === true){

                        this.service_loading = service;
                        service_r = service;

                        request
                                .post('/api/session/update', {
                                    sess_id,
                                    service_r
                                })//, config
                                .then((sess_u) => {
                                    console.log(sess_u);
                                    //load the sess again
                                    request
                                        .post('/api/session/get_by_id', {
                                            id: sess_id
                                        })//, config
                                        .then((sess_n) => {
                                            // here
                                            // this.current_sess = sess_n.data;
                                            // do the time thing
                                            var old_created_at = sess_n.data.createdAt;
                                            sess_n.data.createdAt = useTimeAgo(old_created_at);
                                            this.sessions[this.current_sess_id] = sess_n.data;
                                            this.service_loading = null;
                                        })
                                        .catch((sess_n_err) => {
                                            console.log(sess_n_err);
                                            this.service_loading = null;
                                        });
                                })
                                .catch((sess_u_err) => {
                                    console.log(sess_u_err);
                                    this.service_loading = null;
                                });


                    }
                }else if( service === 'nail_trimming' && this.current_sess.nail_trimming === false ){
                    this.service_loading = service;
                    //deselct hair_cut
                    //and select hair_trimming
                    request
                        .post('/api/session/update', {
                            sess_id,
                            service
                        })//, config
                        .then((sess_u) => {
                            console.log(sess_u);
                            //load the sess again
                            request
                                .post('/api/session/get_by_id', {
                                    id: sess_id
                                })//, config
                                .then((sess_n) => {
                                    // here
                                    // this.current_sess = sess_n.data;
                                    // do the time thing
                                    var old_created_at = sess_n.data.createdAt;
                                    sess_n.data.createdAt = useTimeAgo(old_created_at);
                                    this.sessions[this.current_sess_id] = sess_n.data;
                                    this.service_loading = null;
                                })
                                .catch((sess_n_err) => {
                                    console.log(sess_n_err);
                                    this.service_loading = null;
                                });
                        })
                        .catch((sess_u_err) => {
                            console.log(sess_u_err);
                            this.service_loading = null;
                        });

                    // }else if( service === 'nail_trimming' && this.current_sess.nail_trimming === true && (this.current_sess.shower === true || this.current_sess.medical_shower === true || this.current_sess.hair_cut === true || this.current_sess.hair_trimming === true || this.current_sess.anal_gland === true) && ((this.company === 'pets_club' && this.current_sess.chemical_shower === false) || (this.company !== 'pets_club' && this.current_sess.dry_shower === false))){
                    //  return;
                    //  }

                //remove nail_trimming
                }else if( service === 'nail_trimming' && this.current_sess.nail_trimming === true ){
                    //['shower', 'medical_shower', 'hair_cut', 'hair_trimming', 'nail_trimming', 'anal_gland']
                    if( 
                        this.current_sess.shower === true || 
                        this.current_sess.medical_shower === true ||
                        this.current_sess.dry_shower === true ||
                        this.current_sess.chemical_shower === true ||
                        this.current_sess.hair_cut === true ||
                        this.current_sess.hair_trimming === true ||
                        this.current_sess.anal_gland === true
                    ){

                        this.service_loading = service;
                        service_r = service;

                        request
                                .post('/api/session/update', {
                                    sess_id,
                                    service_r
                                })//, config
                                .then((sess_u) => {
                                    console.log(sess_u);
                                    //load the sess again
                                    request
                                        .post('/api/session/get_by_id', {
                                            id: sess_id
                                        })//, config
                                        .then((sess_n) => {
                                            // here
                                            // this.current_sess = sess_n.data;
                                            // do the time thing
                                            var old_created_at = sess_n.data.createdAt;
                                            sess_n.data.createdAt = useTimeAgo(old_created_at);
                                            this.sessions[this.current_sess_id] = sess_n.data;
                                            this.service_loading = null;
                                        })
                                        .catch((sess_n_err) => {
                                            console.log(sess_n_err);
                                            this.service_loading = null;
                                        });
                                })
                                .catch((sess_u_err) => {
                                    console.log(sess_u_err);
                                    this.service_loading = null;
                                });


                    }
                }else if( service === 'anal_gland' && this.current_sess.anal_gland === false ){
                    this.service_loading = service;
                    //deselct hair_cut
                    //and select hair_trimming
                    request
                        .post('/api/session/update', {
                            sess_id,
                            service
                        })//, config
                        .then((sess_u) => {
                            console.log(sess_u);
                            //load the sess again
                            request
                                .post('/api/session/get_by_id', {
                                    id: sess_id
                                })//, config
                                .then((sess_n) => {
                                    // here
                                    // this.current_sess = sess_n.data;
                                    // do the time thing
                                    var old_created_at = sess_n.data.createdAt;
                                    sess_n.data.createdAt = useTimeAgo(old_created_at);
                                    this.sessions[this.current_sess_id] = sess_n.data;
                                    this.service_loading = null;
                                })
                                .catch((sess_n_err) => {
                                    console.log(sess_n_err);
                                    this.service_loading = null;
                                });
                        })
                        .catch((sess_u_err) => {
                            console.log(sess_u_err);
                            this.service_loading = null;
                        });

                //remove anal_gland
                }else if( service === 'anal_gland' && this.current_sess.anal_gland === true ){
                    //['shower', 'medical_shower', 'hair_cut', 'hair_trimming', 'nail_trimming', 'anal_gland']
                    if(  this.current_sess.shower === true || 
                    this.current_sess.medical_shower === true ||
                    this.current_sess.dry_shower === true ||
                    this.current_sess.chemical_shower === true ||
                    this.current_sess.hair_cut === true ||
                    this.current_sess.hair_trimming === true ||
                    this.current_sess.nail_trimming === true){

                        this.service_loading = service;
                        service_r = service;

                        request
                                .post('/api/session/update', {
                                    sess_id,
                                    service_r
                                })//, config
                                .then((sess_u) => {
                                    console.log(sess_u);
                                    //load the sess again
                                    request
                                        .post('/api/session/get_by_id', {
                                            id: sess_id
                                        })//, config
                                        .then((sess_n) => {
                                            // here
                                            // this.current_sess = sess_n.data;
                                            // do the time thing
                                            var old_created_at = sess_n.data.createdAt;
                                            sess_n.data.createdAt = useTimeAgo(old_created_at);
                                            this.sessions[this.current_sess_id] = sess_n.data;
                                            this.service_loading = null;
                                        })
                                        .catch((sess_n_err) => {
                                            console.log(sess_n_err);
                                            this.service_loading = null;
                                        });
                                })
                                .catch((sess_u_err) => {
                                    console.log(sess_u_err);
                                    this.service_loading = null;
                                });


                    }
                }
            }
        },
        close_money(){
            this.show_money_info = false;
        },
        open_money(){
            this.show_money_info = true;
            // console.log(this.groomer_money, this.finished_sess);
        },
        select_breed_size(giant){
            var sess_id = this.current_sess.id;
            if( this.breed_size_loading === true ){
                return;
            } 
            console.log(sess_id);
            this.breed_size_loading = true;
            giant = !giant;
            request
                .post('/api/session/update_breed_size', {
                    sess_id,
                    giant
                })//, config
                .then(() => {
                    request
                        .post('/api/session/get_by_id', {
                            id: sess_id
                        })//, config
                        .then((sess_n) => {
                            // here
                            // this.current_sess = sess_n.data;
                            // do the time thing
                            var old_created_at = sess_n.data.createdAt;
                            sess_n.data.createdAt = useTimeAgo(old_created_at);
                            this.sessions[this.current_sess_id] = sess_n.data;
                            this.breed_size_loading = null;
                        })
                        .catch((sess_n_err) => {
                            console.log(sess_n_err);
                            this.breed_size_loading = null;
                        });
                })
                .catch((sess_n_err) => {
                    console.log(sess_n_err);
                    this.breed_size_loading = null;
                });
        },
        open_edit_sess(i){
            this.show_sess_edit = true;
            this.current_sess_id = i;
            var sess_id = this.current_sess.id;
            this.temp_sess_update = JSON.parse(JSON.stringify(this.current_sess));
            console.log(this.temp_sess_update, sess_id);
        },
        close_edit(){
            if( this.update_sess_loading && this.update_sess_loading === true ){
                return;
            }
            this.d_error = null;
            this.show_sess_edit = false;
        },
        //func here
        choose_type(type){
            if( this.temp_sess_update && this.temp_sess_update !== null && this.temp_sess_update.pet_type && this.temp_sess_update.pet_type !== null ){
                this.temp_sess_update.pet_type = type;
            }
            
        },

        choose_sex(sex){
            if( this.temp_sess_update && this.temp_sess_update !== null && this.temp_sess_update.pet_sex && this.temp_sess_update.pet_sex !== null ){
                this.temp_sess_update.pet_sex = sex;
            }
        },
        update_sess(){
            if( this.update_sess_loading && this.update_sess_loading === true ){
                return;
            }
            this.d_error = null;
            this.update_sess_loading = true;

            //check if nothing changed
            if( this.current_sess.parent_name === this.temp_sess_update.parent_name
            && this.current_sess.parent_phone === this.temp_sess_update.parent_phone

            && this.current_sess.pet_name === this.temp_sess_update.pet_name
            && this.current_sess.pet_breed === this.temp_sess_update.pet_breed
            && this.current_sess.pet_type === this.temp_sess_update.pet_type
            && this.current_sess.pet_sex === this.temp_sess_update.pet_sex
            && this.current_sess.pet_birthday === this.temp_sess_update.pet_birthday
             ){
                this.d_error = 'you did not change anything';
                this.update_sess_loading = false;
                return;
             }

             // check if parent_name is empty
             if( !this.temp_sess_update.parent_name
             || this.temp_sess_update.parent_name === null
             || this.temp_sess_update.parent_name === undefined
             || this.temp_sess_update.parent_name === ''
             || this.temp_sess_update.parent_name.length === 0 ){
                this.d_error = 'must enter parent name';
                this.update_sess_loading = false;
                return;
             }

             // check if parent_phone is empty
             if( !this.temp_sess_update.parent_phone
             || this.temp_sess_update.parent_phone === null
             || this.temp_sess_update.parent_phone === undefined
             || this.temp_sess_update.parent_phone === ''
             || this.temp_sess_update.parent_phone.length < 6 ){
                this.d_error = 'must enter phone (more then 6 numbers)';
                this.update_sess_loading = false;
                return;
             }

             // check if pet_name is empty
             if( !this.temp_sess_update.pet_name
             || this.temp_sess_update.pet_name === null
             || this.temp_sess_update.pet_name === undefined
             || this.temp_sess_update.pet_name === ''
             || this.temp_sess_update.pet_name.length === 0 ){
                this.d_error = 'must enter pet name';
                this.update_sess_loading = false;
                return;
             }

             // check if pet_name is empty
             if( !this.temp_sess_update.pet_name
             || this.temp_sess_update.pet_name === null
             || this.temp_sess_update.pet_name === undefined
             || this.temp_sess_update.pet_name === ''
             || this.temp_sess_update.pet_name.length === 0 ){
                this.d_error = 'must enter pet name';
                this.update_sess_loading = false;
                return;
             }

             // check if pet_breed is empty
             if( !this.temp_sess_update.pet_breed
             || this.temp_sess_update.pet_breed === null
             || this.temp_sess_update.pet_breed === undefined
             || this.temp_sess_update.pet_breed === ''
             || this.temp_sess_update.pet_breed.length === 0 ){
                this.d_error = 'must enter pet breed';
                this.update_sess_loading = false;
                return;
             }


             // check if pet_birthday is empty
             if( !this.temp_sess_update.pet_birthday
             || this.temp_sess_update.pet_birthday === null
             || this.temp_sess_update.pet_birthday === undefined
             || this.temp_sess_update.pet_birthday === ''
             || this.temp_sess_update.pet_birthday.length === 0 ){
                this.d_error = 'must enter pet birthday';
                this.update_sess_loading = false;
                return;
             }
            


             //lets goo
             request
                .post('/api/session/update_sess_from_admin', this.temp_sess_update)//, config
                .then(() => {
                    this.d_error = null;
                    this.update_sess_loading = false;
                    this.close_edit();
                })
                .catch((sess_n_err) => {
                    console.log(sess_n_err);
                    this.d_error = 'error';
                    this.update_sess_loading = false;
                });


        },

        open_delete(i){
            //hola
            // console.log(this.current_sess, i);
            // this.show_sess_edit = true;
            this.show_sess_delete = true;
            this.current_sess_id = i;
            console.log(this.current_sess.id,  this.sessions.length - i);
        },
        close_delete(){
            if( this.delete_sess_loading && this.delete_sess_loading === true ){
                return;
            }
            this.d_d_error = null;
            this.show_sess_delete = false;
        },
        delete_sess(){
            if( this.delete_sess_loading && this.delete_sess_loading === true ){
                return;
            }
            this.d_d_error = null;
            this.delete_sess_loading = true;
            request
                .post('/api/session/delete_sess', {id: this.current_sess.id})//, config
                .then(() => {
                    this.d_d_error = null;
                    this.delete_sess_loading = false;
                    this.close_delete();
                })
                .catch((delete_sess_err) => {
                    console.log(delete_sess_err);
                    this.d_d_error = 'error';
                    this.delete_sess_loading = false;
                });
        },

        uploadImage(event) {

            //check file count
            if( event.target.files.length > 1 ){
                console.log('file count max is 1');
                return
            }

            for (let img in  event.target.files) {

                if( img === 'length' ){
                    return;
                }

                // img thatsent to server
                this.img = event.target.files[img];


                let reader = new FileReader
                reader.onload = e => {
                    this.parsed_image = e.target.result;
                }
                reader.readAsDataURL(event.target.files[img]);
            }

        },

        save_user(){
            if( this.super_loading === false ){
                this.super_loading = true;
                if( !this.img ){
                    console.log('no img');
                    return;
                }
                var data = new FormData();
                data.append('name', this.super_username);
                data.append('password', this.super_password);
                data.append('role', this.super_role);
                data.append('img', this.img);
                data.append('company', this.super_company);
                data.append('branch', this.super_branch);
                
                console.log(Array.from(data));
                request
                .put('/api/system/register', data)//, config
                .then(() => {
                    // this.d_d_error = null;
                    // this.delete_sess_loading = false;
                    // this.close_delete();
                })
                .catch((delete_sess_err) => {
                    console.log(delete_sess_err);
                    // this.d_d_error = 'error';
                    // this.delete_sess_loading = false;
                });
                this.super_loading = false;


            }

        },

        open_remove_receipt_id_pop_up(receipt_id_){
            console.log(receipt_id_);
            //show conformition pop up to confirm delete receipt id
            this.show_remove_receipt_id_pop_up = receipt_id_;
            this.remove_receipt_id_err = false;
        },

        close_remove_receipt_id_pop_up(){
            this.show_remove_receipt_id_pop_up = null;
        },

        remove_receipt_id(){
            // console.log(this.show_remove_receipt_id_pop_up);
            if(this.remove_receipt_id_loading === true){
                return;
            }
            this.remove_receipt_id_loading = true;
            this.remove_receipt_id_err = false;

            //send to backend (/remove_receipt_id) current_sess_id as id and receipt_id_ as receipt_id if status code is 200 then close pop up
            request
                .post('/api/session/remove_receipt_id', {id: this.current_sess.id, receipt_id: this.show_remove_receipt_id_pop_up})//, config
                .then((d) => {
                    if(d.status === 200){
                        this.remove_receipt_id_loading = false;
                        this.remove_receipt_id_err = false;
                        this.close_remove_receipt_id_pop_up();
                    }else{
                        this.remove_receipt_id_loading = false;
                        this.remove_receipt_id_err = true;
                    }
                })
                .catch((delete_sess_err) => {
                    console.log(delete_sess_err);
                    this.remove_receipt_id_loading = false;
                    this.remove_receipt_id_err = true;
                });
        }

    },
    computed: {
        ...mapState([
            'role',
            'logged_in',
            'company',
            'receipt_number_feature'
            // 'branch_id',
            // 'socket'
        ]),
        current_sess(){
            if( this.current_sess_id !== null ){
                return this.sessions[this.current_sess_id];
            }
            return null;
        },
        finished_sess(){

            // if company is pets_club
            // if( this.company === 'pets_club' ){

            //     return this.sessions.filter( session => 
            //         session.status === 'finished'
            //     );

            // }else{
                // f_sess = this.sessions.filter( session => 
                //     session.status === 'finished'
                //     || session.status === 'picked up'
                // );

                // console.log('-------xxxxxxxx--------',this.sessions);

                var f_arr = [];

                this.sessions.forEach((session, i) => {
                    console.log('xxxxxxxxxxx',session.status, this.is_sess_missing_groomer(i));

                    if( session.status === 'finished' || session.status === 'picked up' ){


                        if( session.multi_groomers && session.multi_groomers !== null && session.multi_groomers.length > 0 ){
                                console.log('=================',this.is_sess_missing_groomer(i), session);
                            
                            if(this.is_sess_missing_groomer(i) === false ){
                                f_arr.push(session);
                                console.log('<<<<<<<<<<<<<<<',f_arr);
                            }
                        }else{
                            if( session.status === 'finished' || session.status === 'picked up' ){
                                f_arr.push(session);
                            }
                        }
                    }
                });
            // }

            // console.log('f_arr', f_arr, this.is_sess_missing_groomer(session.id), );

            return f_arr;
        },
        pets_club_groomer_money(){
            var arr = [];
            this.finished_sess.forEach((session) => {
                var groomer_name = session.groomer_name;
                var groomer_commission = session.groomer_commission;
                if( arr.length > 0 ){
                    arr.forEach(function(g) {
                        if( g[groomer_name] && g[groomer_name] !== null ){
                            g[groomer_name] += Number(groomer_commission);
                        }else{
                            g[groomer_name] = Number(groomer_commission);
                        }
                    });
                }else{
                    var obj = {};
                    obj[groomer_name] = groomer_commission;
                    arr.push(obj);
                }
            });
            return arr;
        },
        groomer_money(){
            // console.log('groomer_money', this.finished_sess);
            var obj = {};
            this.finished_sess.forEach((session) => {
                // if( session.groomer_name && session.groomer_name !== null ){

                    // dog shower
                    if( session.pet_type === 'dog' && session.shower === true ){

                        if( session.groomer_name && session.groomer_name !== null ){

                            if(obj[session.groomer_name] && obj[session.groomer_name] !== null ){
                                obj[session.groomer_name] += 25;
                            }else{
                                obj[session.groomer_name] = 25;
                            }
                            //if giant
                            if( session.giant && session.giant === true ){
                                obj[session.groomer_name] += 25;
                            }

                        }else if( session.multi_groomers && session.multi_groomers.length > 0 ){
                            JSON.parse(session.multi_groomers).forEach((groomer) => {
                                if(obj[groomer.groomer] && obj[groomer.groomer] !== null ){

                                    if( groomer.service === 'shower'  ){
                                        obj[groomer.groomer] += 25;
                                    }
                                    
                                }else{
                                    if( groomer.service === 'shower'  ){
                                        obj[groomer.groomer] = 25;
                                    }
                                }

                                //if giant
                                if( session.giant && session.giant === true ){
                                    if( groomer.service === 'shower'  ){
                                        obj[groomer.groomer] += 25;
                                    }
                                }

                            });
                        }

                    }

                    // dog hair cut
                    if( session.pet_type === 'dog' && session.hair_cut === true ){

                        if( session.groomer_name && session.groomer_name !== null ){

                            if(obj[session.groomer_name] && obj[session.groomer_name] !== null ){
                                obj[session.groomer_name] += 35;
                            }else{
                                obj[session.groomer_name] = 35;
                            }
                            //if giant
                            if( session.giant && session.giant === true ){
                                obj[session.groomer_name] += 35;
                            }

                        }else if( session.multi_groomers && session.multi_groomers.length > 0 ){
                            JSON.parse(session.multi_groomers).forEach((groomer) => {
                                if(obj[groomer.groomer] && obj[groomer.groomer] !== null ){

                                    if( groomer.service === 'hair cut'  ){
                                        obj[groomer.groomer] += 35;
                                    }
                                    
                                }else{
                                    if( groomer.service === 'hair cut'  ){
                                        obj[groomer.groomer] = 35;
                                    }
                                }

                                //if giant
                                if( session.giant && session.giant === true ){
                                    if( groomer.service === 'hair cut'  ){
                                        obj[groomer.groomer] += 35;
                                    }
                                }

                            });
                        }

                    }

                    // dog medical shower
                    
                    if( session.pet_type === 'dog' && session.medical_shower === true ){

                        if( session.groomer_name && session.groomer_name !== null ){

                            if(obj[session.groomer_name] && obj[session.groomer_name] !== null ){
                                obj[session.groomer_name] += 50;
                            }else{
                                obj[session.groomer_name] = 50;
                            }

                        }else if( session.multi_groomers && session.multi_groomers.length > 0 ){
                            JSON.parse(session.multi_groomers).forEach((groomer) => {
                                if(obj[groomer.groomer] && obj[groomer.groomer] !== null ){

                                    if( groomer.service === 'medical shower'  ){
                                        obj[groomer.groomer] += 50;
                                    }
                                    
                                }else{
                                    if( groomer.service === 'medical shower'  ){
                                        obj[groomer.groomer] = 50;
                                    }
                                }

                            });
                        }

                    }

                    //herrre
                    //hair_trimming
                    if( session.pet_type === 'dog' && session.hair_trimming === true ){

                        if( session.groomer_name && session.groomer_name !== null ){

                            if(obj[session.groomer_name] && obj[session.groomer_name] !== null ){
                                obj[session.groomer_name] += 15;
                            }else{
                                obj[session.groomer_name] = 15;
                            }
                        }else if( session.multi_groomers && session.multi_groomers.length > 0 ){
                            JSON.parse(session.multi_groomers).forEach((groomer) => {
                                if(obj[groomer.groomer] && obj[groomer.groomer] !== null ){

                                    if( groomer.service === 'hair trimming'  ){
                                        obj[groomer.groomer] += 15;
                                    }
                                    
                                }else{
                                    if( groomer.service === 'hair trimming'  ){
                                        obj[groomer.groomer] = 15;
                                    }
                                }

                            });
                        }

                    }

                    if( session.pet_type === 'dog' && session.dry_shower === true ){

                        if( session.groomer_name && session.groomer_name !== null ){

                            if(obj[session.groomer_name] && obj[session.groomer_name] !== null ){
                                obj[session.groomer_name] += 15;
                            }else{
                                obj[session.groomer_name] = 15;
                            }

                            console.log('vvvvvvvvvv',obj);

                        }else if( session.multi_groomers && session.multi_groomers.length > 0 ){
                            JSON.parse(session.multi_groomers).forEach((groomer) => {
                                console.log(obj);
                                if(obj[groomer.groomer] && obj[groomer.groomer] !== null ){

                                    if( groomer.service === 'dry shower'  ){
                                        obj[groomer.groomer] += 15;
                                        console.log('ppppppppppppp',obj);

                                    }
                                    
                                }else{
                                    if( groomer.service === 'dry shower'  ){
                                        obj[groomer.groomer] = 15;
                                        console.log('ppppppppppppp22',obj);

                                    }
                                }

                            });
                        }

                    }


                    //////-----------------------
                    // cat shower
                    
                        if( session.pet_type === 'cat' && session.shower === true ){

                            if( session.groomer_name && session.groomer_name !== null ){

                                if(obj[session.groomer_name] && obj[session.groomer_name] !== null ){
                                    obj[session.groomer_name] += 30;
                                }else{
                                    obj[session.groomer_name] = 30;
                                }

                            }else if( session.multi_groomers && session.multi_groomers.length > 0 ){
                                JSON.parse(session.multi_groomers).forEach((groomer) => {
                                    if(obj[groomer.groomer] && obj[groomer.groomer] !== null ){

                                        if( groomer.service === 'shower'  ){
                                            obj[groomer.groomer] += 30;
                                        }
                                        
                                    }else{
                                        if( groomer.service === 'shower'  ){
                                            obj[groomer.groomer] = 30;
                                        }
                                    }

                                });
                            }

                        }


                    // cat hair cut
                    
                        if( session.pet_type === 'cat' && session.hair_cut === true ){

                            if( session.groomer_name && session.groomer_name !== null ){

                                if(obj[session.groomer_name] && obj[session.groomer_name] !== null ){
                                    obj[session.groomer_name] += 35;
                                }else{
                                    obj[session.groomer_name] = 35;
                                }

                            }else if( session.multi_groomers && session.multi_groomers.length > 0 ){
                                JSON.parse(session.multi_groomers).forEach((groomer) => {
                                    if(obj[groomer.groomer] && obj[groomer.groomer] !== null ){

                                        if( groomer.service === 'hair cut'  ){
                                            obj[groomer.groomer] += 35;
                                        }
                                        
                                    }else{
                                        if( groomer.service === 'hair cut'  ){
                                            obj[groomer.groomer] = 35;
                                        }
                                    }

                                });
                            }

                        }


                    // cat medical shower
                    if( session.pet_type === 'cat' && session.medical_shower === true ){

                        if( session.groomer_name && session.groomer_name !== null ){

                            if(obj[session.groomer_name] && obj[session.groomer_name] !== null ){
                                obj[session.groomer_name] += 50;
                            }else{
                                obj[session.groomer_name] = 50;
                            }

                        }else if( session.multi_groomers && session.multi_groomers.length > 0 ){
                            JSON.parse(session.multi_groomers).forEach((groomer) => {
                                if(obj[groomer.groomer] && obj[groomer.groomer] !== null ){

                                    if( groomer.service === 'medical shower'  ){
                                        obj[groomer.groomer] += 50;
                                    }
                                    
                                }else{
                                    if( groomer.service === 'medical shower'  ){
                                        obj[groomer.groomer] = 50;
                                    }
                                }

                            });
                        }

                    }


                    //herrre
                    //hair_trimming
                    if( session.pet_type === 'cat' && session.hair_trimming === true ){

                        if( session.groomer_name && session.groomer_name !== null ){
                            if(obj[session.groomer_name] && obj[session.groomer_name] !== null ){
                                obj[session.groomer_name] += 15;
                            }else{
                                obj[session.groomer_name] = 15;
                            }
                        }else if( session.multi_groomers && session.multi_groomers.length > 0 ){
                            JSON.parse(session.multi_groomers).forEach((groomer) => {
                                if(obj[groomer.groomer] && obj[groomer.groomer] !== null ){

                                    if( groomer.service === 'hair trimming'  ){
                                        obj[groomer.groomer] += 15;
                                    }
                                    
                                }else{
                                    if( groomer.service === 'hair trimming'  ){
                                        obj[groomer.groomer] = 15;
                                    }
                                }

                            });
                        }

                    }

                if (session.pet_type === 'cat' && session.dry_shower === true) {

                    if (session.groomer_name && session.groomer_name !== null) {
                        if (obj[session.groomer_name] && obj[session.groomer_name] !== null) {
                            obj[session.groomer_name] += 15;
                        } else {
                            obj[session.groomer_name] = 15;
                        }
                    } else if (session.multi_groomers && session.multi_groomers.length > 0) {
                        JSON.parse(session.multi_groomers).forEach((groomer) => {
                            if (obj[groomer.groomer] && obj[groomer.groomer] !== null) {

                                if (groomer.service === 'dry shower') {
                                    obj[groomer.groomer] += 15;
                                    // console.log('iiiiiiiiii',obj);
                                }

                            } else {
                                if (groomer.service === 'dry shower') {
                                    obj[groomer.groomer] = 15;
                                    // console.log('uuuuuuuuu',obj);

                                }
                            }

                        });
                    }
                }
                // }
            });
            return obj;
        },


    }
}
</script>

<style scoped>


.c-admin_order_count_number_count{
    width: 300px;
    height: 150px;
    background-color: #ffffff;
    box-shadow: 0 2px 5px 0 rgba(0,0,0,.08)
}

.c-admin_order_count_number_count{
    display: flex;
    justify-content: center;
    align-items: center;
    color: #006837;
    font-size: 100px;
    font-weight: 500
}

.c-admin_order_count_number_count span{
    align-self: center;
    font-family: arial
}

.c-admin_order_count_title{
    font-size: 30px;
    margin-bottom: 10px;
    margin-top: 0px;
    font-weight: 500
}

.stat_cont{
    align-items: center;
}

.accounts_total{
    margin: 20px 0px 40px 0px;
}


.result_table_cont {
    width: 100%;
    border: 1px solid #f2f2f2;
    /* background-color: white; */
    /* box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.08); */
    /* padding: 10px; */
    border-radius: 5px;
    min-width: 940px;
    max-width: 1450px;
}
.result_table_cont table {
    width: 100%;
    border-collapse: collapse;
}
.result_table_cont table tr {
    border-bottom: 1px solid #E6E6E6;
}
.result_table_cont table tr:last-child {
    border-bottom: none;
}
.result_table_cont table tr th {
    text-align: left;
    font-size: 18px;
}
.result_table_cont table tr td {
    font-size: 17px;
    font-weight: 500;
}
.result_table_cont table tr td, .result_table_cont table tr th {
    padding: 10px 0px;
}

.scroll_y {
    overflow-x: auto;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.08);
    background-color: white;
    border-radius: 5px;
}

.edit_product_table{
    height: 30px;
}

.product_edit_cont{
    position: fixed;
    top: 0px;
    left: 0px;
    background-color: rgba(0, 0, 0, 0.08);
    display: flex;
    align-items: center;
    padding: 0px 10px;
    width: 100vw;
    height: 100vh;
    justify-content: center;
}

.product_edit{
    width: 100%;
    max-width: 500px;
    background-color: white;
    padding: 15px;
    border-radius: 3px;
    box-shadow: 0 2px 5px 0 rgb(0 0 0 / 8%);
    border: 1px solid #ccc;
}

.product_edit .secondary {
    margin-top: 10px;
}

.no__{
    width: 100%;
    max-width: 500px;
    margin: auto;
    padding: 10px 15px;
    background-color: #cae6ff;
    border-radius: 3px;
    text-align: center;
    font-size: 20px;
    font-weight: 500;
}

.no_result_center{
    padding: 10px;
    border-radius: 3px;
    width: 100%;
    background-color: #cccccc8c;
    /* display: flex; */
    /* width: 100vw; */
    text-align: center;
    /* color: #673AB7; */
    color: #373737;
    font-weight: 500;
}
/* .pageloading_cont{
    height: 200px;
} */

.spinner_cont_page_{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 25vh;
}

.spinner_cont_page_ .spinner_circle{
    height: 100px;
}

.manage{
    color: #317BEB;
    cursor: pointer;
    width: fit-content;
    margin: auto;
}

.sess_info_cont{
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: #00000052;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.sess_info{
    margin-top: 5%;
    background-color: white;
    width: 90%;
    max-width: 500px;
    padding: 10px;
    border-radius: 3px;
    overflow-y: auto;
    max-height: 85%;
}

.close_cont{
    display: flex;
    flex-direction: column;
}

.close{
    text-align: end;
    color: red;
    font-weight: bold;
    width: fit-content;
    align-self: end;
    cursor: pointer;
}

.groomers_heading{
    margin-bottom: 15px;
    font-weight: bold;
}

.groomer{
    cursor: pointer;
    background-color: #cccccca8;
    padding: 6px 10px;
    border-radius: 50px;
    margin-right: 5px;
    margin-bottom: 7px
}

.service{
    font-size: 20px;
    margin-bottom: 10px;
}

.other{
    border: 1px solid;
    padding: 3px 5px;
    border-radius: 3px;
    background-color: #33333314;
}

hr{
    margin-top: 25px;
    border: 1px solid;
}

.pet_name{
    font-size: 20px;
    text-align: center;
    width: fit-content;
    margin: auto;
    padding: 5px 10px;
    border: 2px solid;
    border-radius: 3px;
}

.pet_info{
    font-size: 20px;
    text-align: center;
    margin-top: 7px;
}

.groomer_selected{
    background-color: #0000ff70;
    cursor: auto;
}

.heading_cont_{
    justify-content: space-between;
    align-items: center;
}
.money{
    color: #317BEB;
    cursor: pointer;
    font-size: 17px;
    font-weight: 500;
}

.money_txt{
    font-size: 25px;
}

.money_info{
    padding: 10px 10px 10px 25px;
}
.groomers_names_cont{
    flex-wrap: wrap;
}

/* tr:nth-child(even){background-color: #f2f2f2;} */

/* .parent_name{
    padding-left: 12px !important;
} */

td, th {
    /* border: 1px solid #ddd; */
    padding: 8px !important;
}

.manage_td{
    margin: auto;
}

tr:hover{
    background-color: #317beb0d;
    /* cursor: pointer; */
}

.not_hover:hover{
    background-color: transparent;
    cursor: auto;
    
}

.no_money{
    text-align: center;
    color: #5d5d5d;
    padding: 15px 0px;
    font-size: 18px;
}

.tr_showering{
    border-left: 5px solid #2196f3;
}

.tr_waiting{
    border-left: 5px solid #ffc107;
}

.tr_finished{
    border-left: 5px solid #ff7480;
}

.tr_waiting_outside{
    border-left: 5px solid #5a189a;
}

.tr_canceled{
    border-left: 5px solid #e40b0b;
}

.tr_picked_up{
    border-left: 5px solid green;
}

.service{
    cursor: pointer;
}

.pointer{
    cursor: pointer;
}

.edit_icon{
    height: 30px;
    display: flex;
    cursor: pointer;
}

.label_img_cont{
border: 2px solid #365889;
border: 2px solid #c7c7c7;
border-radius: 3px;
display: flex;
align-items: center;
justify-content: center;
height: 40px;
width: 60px;
background-color: lightgrey;
cursor: pointer;
}

.label_img{
height: 20px;
width: auto;
}
.pet_name_cont{
    align-items: end;
    margin-bottom: 5px;
}

.edit_cont_input{
    height: 40px;
    width: 100%;
    display: flex;
}

.edit_cont_input_date{
    width: 100%;
    margin-top: 15px;
}

.mr{
    margin-left: 10px;
    margin-right: 7px;
}

.selected{
    border-color: #365889;
    background-color: #36588942;
}

.back_btn{
    border-width: 2px;
}

.btn_first_grooming{
    font-size: 20px;
    padding: 10px 35px;
    border-radius: 5px;
}

.btns_cont{
    justify-content: space-between;
    margin-top: 10px;
}

.back_btn {
    background-color: transparent;
    border: 1px solid #5d8ced;
    /* font-weight: bold; */
    color: #5d8ced;
}

.edit_phone_input{
    margin-top: 10px;
}

.delete_title{
    font-size: 25px;
    font-weight: 500;
    /* text-align: center; */
    margin: 25px 0px;
}


input{
    display: block;
    width: 100%;
    padding: 5px 10px;
    /* background-color: #d2dbf3; */
    background-color: #fff;
    /* border: 1px solid #647193; */
    border: 2px solid #ccc;
    /* border-right: 0px; */
    border-radius: 5px;
    font-size: 18px;
    /* -webkit-transition: 0.3s; */
    transition: 0.1s;
    outline: none;
    min-height: 40px;
    font-family: inherit;
    /* resize: vertical; */
    /* margin-bottom: 20px; */
    background-color: #cccccc08;
}

input:focus{
    border: 2px solid #317BEB;
    background-color: white;
}

button{
    padding: 5px 15px !important;
    font-size: 18px;
}

.groomers_heading{
    font-size: 20px;
}

.delete_btn{
    background-color: red;
}

.delete_txt{
    color: whitesmoke;
}

.no_mr{
    margin: 0px;
}

.super_form_cont{
    align-items: center;
    margin-bottom: 50px;
}

.super_form_cont input{
    margin-bottom: 10px;
}

/* ---------------------------------------- */
.super_form{
    width: 100%;
    max-width: 500px;
    padding: 10px;
    background-color: white;
    border-radius: 5px;
    border: 1px solid;
}

.groomer_commission{
    border: 1.5px solid #ccc;
    border-radius: 0px;
    background-color: #f8f6f6;
    border-right: 0px;
    border-radius: 5px 0px 0px 5px;
}

.groomer_commission:focus{
    /* border-color: #000; */
    border: 1.5px solid #317beb;
    border-right: 0px;
}

.groomer_commission_btn{
    background-color: #317beb;
    color: #f2f2f2;
    outline: none;
    border: 0px solid #000;
    cursor: pointer;
    border-radius: 0px 5px 5px 0px;
}

.groomer_input{
    margin-top: 5px;
}

.no_poienter{
    cursor: auto;
}

.err{
    font-size: 15px;
    color: red;
}

.good{
    font-size: 15px;
    color: green;  
}

.receipt_cont{
    margin-top: 25px;
}

.receipt_ids_cont{
    margin-top: 15px;
    flex-wrap: wrap;
}

.receipt_id{
    background-color: #ccc;
    padding: 5px 15px;
    border: 1px solid black;
}

.main_input{
    border-color: #999999;
    /* color: #7c7c7c; */
}

.remove_receipt_id_pop_up{
    background-color: #000000ba;
    position: fixed;
    top: 0;
    width: 100%;
    left: 0;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.remove_receipt_id_pop_up_cont{
    background-color: white;
    padding: 15px;
    border-radius: 5px;
    width: 90%;
    max-width: 500px;
}

.remove_receipt_id_pop_up_btns_cont{
    justify-content: flex-end;
}

.remove_receipt_id_pop_up_btn_cancel{
    margin-right: 25px;
    background-color: transparent;
    border: 0px;
    color: red;
    cursor: pointer;
    font-size: 20px;
    font-weight: 500;
    padding: 0px !important;
}

.remove_receipt_id_pop_up_title{
    font-size: 25px;
    font-weight: 500;
    margin-bottom: 10px;
}

.multiple_groomers_btn{
    cursor: pointer;
    color: #317BEB;
    font-size: 17px;
    font-weight: 500;
}

.multiple_groomers_btn:hover{
    text-decoration: underline;
}

.choose_groomer_cont{
    justify-content: space-between;
}

.space_between{
    justify-content: space-between;
}

.cencel_assign_groomers{
    color: #317BEB;
}

.mr_top_15{
    margin-top: 15px;
}

.service_assign_g{
    margin-top: 10px;
}

.service_assign_g div{
    font-size: 20px;
}

.groomer.groomer_selected_multi {
    background-color: #0000ff3d;
    cursor: pointer;
    border: 2px solid #0000ff70;
}

.missing_groomer{
    /* background-color: red;
    border-bottom: 2px solid red;
    border-top: 2px solid red;
    border-right: 2px solid red; */
    background-color: #ff00001f;
}

.missing_groomer:hover{
    background-color: #ff000026;
}

.dollar_sign{
    font-size: 20px !important;
    font-weight: 500 !important;
}

.add_phone_btn_{
    /* text-align: right;
    margin-top: 10px; */
    margin: 10px 0px;
    width: fit-content;
}

.phone_hr{
    margin-top: 10px;
}

.phone_2_input{
    border: 1.5px solid #ccc;
    /* border-radius: 0px; */
    background-color: #f8f6f6;
    /* border-right: 0px; */
    border-radius: 5px;
}

.phone_2_input:focus{
    border: 1.5px solid #317beb;
}

.another_phone{
    font-size: 17px;
    font-weight: 500;
}

.add_phone_to_all_cont{
    margin-top: 20px;
    align-items: center;
}

.font_size_15{
    font-size: 15px;
    cursor: pointer;
}

.add_phone_to_all{
    /* width: auto; */
    min-height: auto;
    /* margin-left: 5px; */
    height: 14px;
    width: 14px;
    margin: 0px;
    margin-right: 5px;
    cursor: pointer;
}

/* li:nth-child(1n) { color:green; }
li:nth-child(2n) { color:red; } */

.another_phone_cont:nth-child(1n){
    background-color: #cccccc8a;
    padding: 5px;
}

.another_phone_cont:nth-child(2n){
    background-color: #cccccc;
    padding: 5px;
}

.font_size_14{
    font-size: 14px;
    cursor: pointer;
}

.groomer_td{
    max-width: 100px;
}
</style>